import * as React from 'react';
import { Icon } from '@chakra-ui/react';

type IconProps = React.FC<Omit<React.ComponentProps<typeof Icon>, 'children'>>;
export const iconVariant: IconVariant[] = [
  'AccountsManagement',
  'Accounts',
  'Add',
  'ArrowDownward',
  'ArrowUpward',
  'Backspace',
  'BlackListed',
  'Broom',
  'BookingSourceView',
  'CalendarAdd',
  'CalendarEvent',
  'CalendarMain',
  'CalendarOutline',
  'CaretCheck',
  'CaretDown',
  'CaretLeft',
  'CaretRight',
  'CaretUp',
  'CheckCircle',
  'Clock',
  'Clog',
  'Close',
  'CloseAccount',
  'Collapse',
  'CreditCard',
  'Customer',
  'Dashboard',
  'DetailView',
  'Dollar',
  'Download',
  'Duplicate',
  'Email',
  'EmailLog',
  'EmailServices',
  'Emoji',
  'Empty',
  'ExternalLink',
  'File',
  'Filter',
  'Fire',
  'FormatAlignCenter',
  'FormatAlignJustify',
  'FormatAlignLeft',
  'FormatAlignRight',
  'FormatBold',
  'FormatItalic',
  'FormatListBullet',
  'FormatListNumber',
  'FormatTextColor',
  'FormatUnderline',
  'GroupView',
  'Help',
  'Image',
  'InfoCircle',
  'Inventory',
  'Links',
  'Lock',
  'Loyalty',
  'Minus',
  'MonthView',
  'MoreHorizontal',
  'NightlyRatesView',
  'NormalView',
  'Palette',
  'Password',
  'Pin',
  'Print',
  'Progress',
  'QuarterView',
  'Reverse',
  'RoomAvailabilities',
  'RowCondense',
  'ScrollDown',
  'ScrollUp',
  'Search',
  'SendFeedback',
  'Sort',
  'SortDown',
  'SortUp',
  'Split',
  'Star',
  'SetOfStars',
  'Stop',
  'Switch',
  'Template',
  'ToggleOff',
  'ToggleOn',
  'Trash',
  'Undo',
  'Unlink',
  'Upload',
  'View',
  'Warning',
  'ViewInput',
  'Preview',
  'Refresh',
  'SendText',
  'NoShow',
  'Group',
  'Company',
  'Profile',
  'ArrowLeftRight',
  'SplitArrow',
  'ReverseArrow',
  'FillGrid',
  'ThList',
  'Settlements',
  'Transactions',
  'Paid',
  'Refund',
  'Pending',
  'Completed',
  'Failed',
  'InProgress',
  'Notifications',
  'RevenueChart',
  'PendingSettlement',
];
export type IconVariant =
  | 'AccountsManagement'
  | 'Accounts'
  | 'Add'
  | 'ArrowDownward'
  | 'ArrowUpward'
  | 'Backspace'
  | 'BlackListed'
  | 'Broom'
  | 'BookingSourceView'
  | 'CalendarAdd'
  | 'CalendarEvent'
  | 'CalendarMain'
  | 'CalendarOutline'
  | 'CaretCheck'
  | 'CaretDown'
  | 'CaretLeft'
  | 'CaretRight'
  | 'CaretUp'
  | 'CheckCircle'
  | 'Clock'
  | 'Clog'
  | 'Close'
  | 'CloseAccount'
  | 'Collapse'
  | 'CreditCard'
  | 'Customer'
  | 'Dashboard'
  | 'DetailView'
  | 'Dollar'
  | 'Download'
  | 'Duplicate'
  | 'Email'
  | 'EmailLog'
  | 'EmailServices'
  | 'Emoji'
  | 'Empty'
  | 'ExternalLink'
  | 'File'
  | 'Filter'
  | 'Fire'
  | 'FormatAlignCenter'
  | 'FormatAlignJustify'
  | 'FormatAlignLeft'
  | 'FormatAlignRight'
  | 'FormatBold'
  | 'FormatItalic'
  | 'FormatListBullet'
  | 'FormatListNumber'
  | 'FormatTextColor'
  | 'FormatUnderline'
  | 'GroupView'
  | 'Help'
  | 'Image'
  | 'InfoCircle'
  | 'Inventory'
  | 'Links'
  | 'Lock'
  | 'Logout'
  | 'Loyalty'
  | 'Minus'
  | 'MonthView'
  | 'MoreHorizontal'
  | 'NightlyRatesView'
  | 'NormalView'
  | 'Palette'
  | 'Password'
  | 'Pin'
  | 'Print'
  | 'Progress'
  | 'QuarterView'
  | 'Reverse'
  | 'RoomAvailabilities'
  | 'RowCondense'
  | 'ScrollDown'
  | 'ScrollUp'
  | 'Search'
  | 'SendFeedback'
  | 'Sort'
  | 'SortDown'
  | 'SortUp'
  | 'Split'
  | 'Star'
  | 'SetOfStars'
  | 'Stop'
  | 'Switch'
  | 'Template'
  | 'ToggleOff'
  | 'ToggleOn'
  | 'Trash'
  | 'Undo'
  | 'Unlink'
  | 'Upload'
  | 'View'
  | 'Warning'
  | 'ViewInput'
  | 'Preview'
  | 'Refresh'
  | 'SendText'
  | 'NoShow'
  | 'Group'
  | 'Company'
  | 'Profile'
  | 'ArrowLeftRight'
  | 'SplitArrow'
  | 'ReverseArrow'
  | 'FillGrid'
  | 'ThList'
  | 'Settlements'
  | 'Transactions'
  | 'Paid'
  | 'Refund'
  | 'Pending'
  | 'Completed'
  | 'Failed'
  | 'InProgress'
  | 'Notifications'
  | 'RevenueChart'
  | 'PendingSettlement';

export const AccountsManagement: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M10 11C12.2091 11 14 9.20914 14 7C14 4.79086 12.2091 3 10 3C7.79086 3 6 4.79086 6 7C6 9.20914 7.79086 11 10 11Z"
      fill="currentColor"
    />
    <path
      d="M10.67 12.02C10.45 12.01 10.23 12 10 12C7.58 12 5.32 12.67 3.39 13.82C2.51 14.34 2 15.32 2 16.35V19H11.26C10.47 17.87 10 16.49 10 15C10 13.93 10.25 12.93 10.67 12.02Z"
      fill="currentColor"
    />
    <path
      d="M20.75 15C20.75 14.78 20.72 14.58 20.69 14.37L21.83 13.36L20.83 11.63L19.38 12.12C19.06 11.85 18.7 11.64 18.3 11.49L18 10H16L15.7 11.49C15.3 11.64 14.94 11.85 14.62 12.12L13.17 11.63L12.17 13.36L13.31 14.37C13.28 14.58 13.25 14.78 13.25 15C13.25 15.22 13.28 15.42 13.31 15.63L12.17 16.64L13.17 18.37L14.62 17.88C14.94 18.15 15.3 18.36 15.7 18.51L16 20H18L18.3 18.51C18.7 18.36 19.06 18.15 19.38 17.88L20.83 18.37L21.83 16.64L20.69 15.63C20.72 15.42 20.75 15.22 20.75 15ZM17 17C15.9 17 15 16.1 15 15C15 13.9 15.9 13 17 13C18.1 13 19 13.9 19 15C19 16.1 18.1 17 17 17Z"
      fill="currentColor"
    />
  </Icon>
);

export const Accounts: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.41 18.09V20H10.74V18.07C9.03 17.71 7.58 16.61 7.47 14.67H9.43C9.53 15.72 10.25 16.54 12.08 16.54C14.04 16.54 14.48 15.56 14.48 14.95C14.48 14.12 14.04 13.34 11.81 12.81C9.33 12.21 7.63 11.19 7.63 9.14C7.63 7.42 9.02 6.3 10.74 5.93V4H13.41V5.95C15.27 6.4 16.2 7.81 16.26 9.34H14.3C14.25 8.23 13.66 7.47 12.08 7.47C10.58 7.47 9.68 8.15 9.68 9.11C9.68 9.95 10.33 10.5 12.35 11.02C14.37 11.54 16.53 12.41 16.53 14.93C16.52 16.76 15.15 17.76 13.41 18.09Z"
      fill="currentColor"
    />
  </Icon>
);

export const Add: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="currentColor" />
  </Icon>
);

export const ArrowDownward: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M6.22771 12.5527L9.96043 16.2854V2.45772C9.96043 1.65265 10.6131 1 11.4182 1H12.5843C13.3894 1 14.0421 1.65265 14.0421 2.45772V16.2829L17.7723 12.5527C18.2277 12.0973 18.9661 12.0973 19.4215 12.5527L20.6584 13.7896C21.1139 14.245 21.1139 14.9834 20.6584 15.4388L13.0308 23.0665C12.4615 23.6358 11.5385 23.6358 10.9692 23.0665L3.34156 15.4388C2.88614 14.9834 2.88615 14.245 3.34156 13.7896L4.57848 12.5527C5.0339 12.0973 5.77229 12.0973 6.22771 12.5527Z"
      fill="currentColor"
    />
  </Icon>
);

export const ArrowUpward: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M17.7723 11.9408L14.0396 8.20804V22.0357C14.0396 22.8408 13.3869 23.4935 12.5819 23.4935H11.4157C10.6106 23.4935 9.95795 22.8408 9.95795 22.0357V8.21053L6.22771 11.9408C5.77229 12.3962 5.0339 12.3962 4.57848 11.9408L3.34157 10.7038C2.88614 10.2484 2.88615 9.51004 3.34157 9.05462L10.9692 1.42696C11.5385 0.857686 12.4615 0.857677 13.0308 1.42696L20.6584 9.05462C21.1139 9.51004 21.1139 10.2484 20.6584 10.7038L19.4215 11.9408C18.9661 12.3962 18.2277 12.3962 17.7723 11.9408Z"
      fill="currentColor"
    />
  </Icon>
);

export const Backspace: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 3H7C6.31 3 5.77 3.35 5.41 3.88L0 12L5.41 20.11C5.77 20.64 6.31 21 7 21H22C23.1 21 24 20.1 24 19V5C24 3.9 23.1 3 22 3ZM19 15.59L17.59 17L14 13.41L10.41 17L9 15.59L12.59 12L9 8.41L10.41 7L14 10.59L17.59 7L19 8.41L15.41 12L19 15.59Z"
      fill="currentColor"
    />
  </Icon>
);

export const BlackListed: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 3C16.9703 3 21 7.02975 21 12C21 16.9703 16.9703 21 12 21C7.02975 21 3 16.9703 3 12C3 7.02975 7.02975 3 12 3ZM17.625 10.875H6.375V13.125H17.625V10.875Z"
      fill="currentColor"
    />
  </Icon>
);

export const Broom: IconProps = (props) => (
  <Icon viewBox="0 0 14 16" {...props}>
    <path
      d="M8.49909 6.43843L10.3555 6.70407C10.7593 6.76175 11.1525 6.88471 11.1798 7.3826C11.1889 7.55109 11.1494 7.74387 11.1236 7.98674L11.11 8.1188C11.0568 8.60758 10.9202 8.55142 10.5195 8.74724C11.5213 10.3897 12.6765 12.1262 13.0332 14.0737C13.1122 14.4745 12.8556 14.7371 12.3471 14.898L11.4379 15.068C11.5274 14.01 11.2481 12.8973 10.6546 11.7391C10.817 13.0597 10.9794 14.347 10.7639 15.1075L9.82882 15.2835C9.69372 14.857 9.58291 14.5276 9.39165 14.391L9.17458 15.2077L7.60046 15.1302C8.16666 14.265 8.51427 13.3315 8.60687 12.3159C8.11353 13.4119 7.56555 14.224 6.95078 14.7098C6.66237 15.0058 6.41039 15.0665 6.19484 14.8767C6.04152 14.7416 6.06581 14.6582 6.09769 14.4608C6.13867 14.2058 6.24037 13.9432 6.38154 13.6806C6.06429 14.0373 5.86392 14.1238 5.6848 14.3136C5.17932 14.8555 4.30498 14.772 4.16533 14.0206C4.07577 13.5394 4.39606 13.3846 4.7209 13.0446L5.28558 12.4541C4.65259 12.8503 4.01809 13.2298 3.37903 13.4681C2.64434 13.7428 2.6413 13.714 1.96733 13.3649C1.0596 12.8958 0.384105 12.36 1.64704 12.0366C3.97255 11.2716 6.24037 10.3714 8.02701 8.34498C7.83878 8.23113 7.73556 8.08389 7.70368 7.91084C7.65359 7.65279 7.8236 6.8422 8.00576 6.65094C8.12112 6.5295 8.28354 6.45664 8.49909 6.43843ZM10.5256 1.33203C10.8079 0.258835 11.9115 0.472867 11.9433 1.44739L10.5954 5.4047C10.3798 6.55379 9.01975 6.44754 9.14726 5.27871L10.5256 1.33203Z"
      fill="currentColor"
    />
  </Icon>
);

export const BookingSourceView: IconProps = (props) => (
  <Icon viewBox="0 0 16 17" {...props}>
    <path
      d="M4.16668 11.8387V14.8387H1.33334V11.8387H4.16668ZM7.66668 11.8387V14.8387H4.83334V11.8387H7.66668ZM10.5333 3.8387L11.0833 4.3887H14.75C15.0525 4.3887 15.3 4.6362 15.3 4.9387V14.222C15.3 14.5245 15.0525 14.772 14.75 14.772H8.88334C8.58084 14.772 8.33334 14.5245 8.33334 14.222L8.33609 4.3887C8.33609 4.0862 8.58084 3.8387 8.88334 3.8387H10.5333ZM4.16668 7.8387V10.8387H1.33334V7.8387H4.16668ZM7.66668 7.8387V10.8387H4.83334V7.8387H7.66668ZM10.9 8.7887H8.70001V9.3387H10.9V8.7887ZM14.64 7.42565H8.70001V8.09204H14.64V7.42565ZM4.16668 3.8387V6.8387H1.33334V3.8387H4.16668ZM7.66668 3.8387V6.8387H4.83334V3.8387H7.66668ZM13.9733 5.95898H8.70001V6.62537H13.9733V5.95898ZM14.6667 1.50537V2.8387H1.33334V1.50537H14.6667Z"
      fill="currentColor"
    />
  </Icon>
);

export const CalendarAdd: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM10.875 9V12.375H7.5V14.625H10.875V18H13.125V14.625H16.5V12.375H13.125V9H10.875Z"
      fill="currentColor"
    />
  </Icon>
);

export const CalendarEvent: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM7 13.7434L10.2566 17L16.9115 10.4159L15.4956 9L10.2566 14.2389L8.41593 12.3982L7 13.7434Z"
      fill="currentColor"
    />
  </Icon>
);

export const CalendarMain: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M7 13V11H9V13H7Z" fill="currentColor" />
    <path d="M11 11H13V13H11V11Z" fill="currentColor" />
    <path d="M15 13V11H17V13H15Z" fill="currentColor" />
    <path d="M17 16V14H15V16H17Z" fill="currentColor" />
    <path d="M11 14H13V16H11V14Z" fill="currentColor" />
    <path d="M9 14H7V16H9V14Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 4H19C20.1 4 21 4.9 21 6V20C21 21.1 20.1 22 19 22H5C3.89 22 3 21.1 3 20L3.01 6C3.01 4.9 3.89 4 5 4H6V2H8V4H16V2H18V4ZM5 20H19V9H5V20Z"
      fill="currentColor"
    />
  </Icon>
);

export const CalendarOutline: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#clip0)">
      <path
        d="M20.6364 2.18182H19.5455V0H17.3636V2.18182H6.45455V0H4.27273V2.18182H3.18182C1.98182 2.18182 1 3.16364 1 4.36364V21.8182C1 23.0182 1.98182 24 3.18182 24H20.6364C21.8364 24 22.8182 23.0182 22.8182 21.8182V4.36364C22.8182 3.16364 21.8364 2.18182 20.6364 2.18182ZM20.6364 21.8182H3.18182V7.63636H20.6364V21.8182Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="24" fill="currentColor" />
      </clipPath>
    </defs>
  </Icon>
);

export const CaretCheck: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M9.6 17.3L5 12.7L7 10.8L9.6 13.4L17 6L19 8L9.6 17.3Z" fill="currentColor" />
  </Icon>
);

export const CaretDown: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M5 9.21255L6.71255 7.5L12.2874 13.0628L17.8623 7.5L19.5749 9.21255L12.2874 16.5L5 9.21255Z"
      fill="currentColor"
    />
  </Icon>
);

export const CaretLeft: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M14.7874 5L16.5 6.71255L10.9372 12.2874L16.5 17.8623L14.7874 19.5749L7.5 12.2874L14.7874 5Z"
      fill="currentColor"
    />
  </Icon>
);

export const CaretRight: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9.21255 5L7.5 6.71255L13.0628 12.2874L7.5 17.8623L9.21255 19.5749L16.5 12.2874L9.21255 5Z"
      fill="currentColor"
    />
  </Icon>
);

export const CaretUp: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M5 14.7875L6.71255 16.5L12.2874 10.9372L17.8623 16.5L19.5749 14.7874L12.2874 7.5L5 14.7875Z"
      fill="currentColor"
    />
  </Icon>
);

export const CheckCircle: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
      fill="currentColor"
    />
  </Icon>
);

export const Clock: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
      fill="currentColor"
    />
    <path d="M12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" fill="currentColor" />
    <path
      d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
      stroke="#63686C"
      strokeWidth="0.5"
    />
    <path d="M12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" stroke="#63686C" strokeWidth="0.5" />
  </Icon>
);

export const Clog: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19.14 12.94C19.18 12.64 19.2 12.33 19.2 12C19.2 11.68 19.18 11.36 19.13 11.06L21.16 9.47999C21.34 9.33999 21.39 9.06999 21.28 8.86999L19.36 5.54999C19.24 5.32999 18.99 5.25999 18.77 5.32999L16.38 6.28999C15.88 5.90999 15.35 5.58999 14.76 5.34999L14.4 2.80999C14.36 2.56999 14.16 2.39999 13.92 2.39999H10.08C9.83999 2.39999 9.64999 2.56999 9.60999 2.80999L9.24999 5.34999C8.65999 5.58999 8.11999 5.91999 7.62999 6.28999L5.23999 5.32999C5.01999 5.24999 4.76999 5.32999 4.64999 5.54999L2.73999 8.86999C2.61999 9.07999 2.65999 9.33999 2.85999 9.47999L4.88999 11.06C4.83999 11.36 4.79999 11.69 4.79999 12C4.79999 12.31 4.81999 12.64 4.86999 12.94L2.83999 14.52C2.65999 14.66 2.60999 14.93 2.71999 15.13L4.63999 18.45C4.75999 18.67 5.00999 18.74 5.22999 18.67L7.61999 17.71C8.11999 18.09 8.64999 18.41 9.23999 18.65L9.59999 21.19C9.64999 21.43 9.83999 21.6 10.08 21.6H13.92C14.16 21.6 14.36 21.43 14.39 21.19L14.75 18.65C15.34 18.41 15.88 18.09 16.37 17.71L18.76 18.67C18.98 18.75 19.23 18.67 19.35 18.45L21.27 15.13C21.39 14.91 21.34 14.66 21.15 14.52L19.14 12.94ZM12 15.6C10.02 15.6 8.39999 13.98 8.39999 12C8.39999 10.02 10.02 8.39999 12 8.39999C13.98 8.39999 15.6 10.02 15.6 12C15.6 13.98 13.98 15.6 12 15.6Z"
      fill="currentColor"
    />
  </Icon>
);

export const Close: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
      fill="currentColor"
    />
  </Icon>
);

export const CloseAccount: IconProps = (props) => (
  <Icon width="16" height="17" viewBox="0 0 16 17" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.3335 8.97917C1.3335 5.29917 4.32016 2.3125 8.00016 2.3125C11.6802 2.3125 14.6668 5.29917 14.6668 8.97917C14.6668 12.6592 11.6802 15.6458 8.00016 15.6458C4.32016 15.6458 1.3335 12.6592 1.3335 8.97917ZM3.90683 12.3925C5.0335 11.5125 6.4535 10.9792 8.00016 10.9792C8.3935 10.9792 8.78016 11.0125 9.16016 11.0792L7.6935 9.6125C6.6535 9.47917 5.84016 8.65917 5.70016 7.61917L3.7935 5.7125C3.08683 6.6125 2.66683 7.74583 2.66683 8.97917C2.66683 10.2792 3.1335 11.4658 3.90683 12.3925ZM4.7335 4.7725L12.2068 12.2458C12.9135 11.3392 13.3335 10.2125 13.3335 8.97917C13.3335 6.0325 10.9468 3.64583 8.00016 3.64583C6.76683 3.64583 5.6335 4.06583 4.7335 4.7725ZM10.3335 7.3125C10.3335 7.65917 10.2535 7.97917 10.1202 8.2725L7.04016 5.1925C7.33349 5.05917 7.65349 4.97917 8.00016 4.97917C9.28683 4.97917 10.3335 6.02583 10.3335 7.3125Z"
      fill="#D62F1D"
    />
  </Icon>
);

export const Collapse: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.8182 22H1V2H22.8182V22ZM21 3.81818H8.27273V20.1818H21V3.81818Z"
      fill="currentColor"
    />
    <path
      d="M15.5455 7.45455L16.6136 8.52273L13.1439 12L16.6136 15.4773L15.5455 16.5455L11 12L15.5455 7.45455Z"
      fill="currentColor"
    />
  </Icon>
);

export const CreditCard: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M1 8.66667V6.83333C1 5.82133 1.82133 5 2.83333 5H21.1667C22.1787 5 23 5.82133 23 6.83333V8.66667H1ZM23 11.4167V17.8333C23 18.8453 22.1787 19.6667 21.1667 19.6667H2.83333C1.82133 19.6667 1 18.8453 1 17.8333V11.4167H23ZM9.25 16H3.75V16.9167H9.25V16ZM12 14.1667H3.75V15.0833H12V14.1667ZM20.25 14.1667H17.5V15.0833H20.25V14.1667Z"
      fill="currentColor"
    />
  </Icon>
);

export const Customer: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 12.75C13.63 12.75 15.07 13.14 16.24 13.65C17.32 14.13 18 15.21 18 16.38V18H6V16.39C6 15.21 6.68 14.13 7.76 13.66C8.93 13.14 10.37 12.75 12 12.75ZM4 13C5.1 13 6 12.1 6 11C6 9.9 5.1 9 4 9C2.9 9 2 9.9 2 11C2 12.1 2.9 13 4 13ZM5.13 14.1C4.76 14.04 4.39 14 4 14C3.01 14 2.07 14.21 1.22 14.58C0.48 14.9 0 15.62 0 16.43V18H4.5V16.39C4.5 15.56 4.73 14.78 5.13 14.1ZM20 13C21.1 13 22 12.1 22 11C22 9.9 21.1 9 20 9C18.9 9 18 9.9 18 11C18 12.1 18.9 13 20 13ZM24 16.43C24 15.62 23.52 14.9 22.78 14.58C21.93 14.21 20.99 14 20 14C19.61 14 19.24 14.04 18.87 14.1C19.27 14.78 19.5 15.56 19.5 16.39V18H24V16.43ZM12 6C13.66 6 15 7.34 15 9C15 10.66 13.66 12 12 12C10.34 12 9 10.66 9 9C9 7.34 10.34 6 12 6Z"
      fill="currentColor"
    />
  </Icon>
);

export const Dashboard: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7.5 21H2V9H7.5V21ZM14.75 3H9.25V21H14.75V3ZM22 11H16.5V21H22V11Z"
      fill="currentColor"
    />
  </Icon>
);

export const DetailView: IconProps = (props) => (
  <Icon viewBox="0 0 16 17" {...props}>
    <path
      d="M4.16668 9.8387V14.8387H1.33334V9.8387H4.16668ZM7.66668 9.8387V14.8387H4.83334V9.8387H7.66668ZM11.1667 9.8387V14.8387H8.33334V9.8387H11.1667ZM14.6667 9.8387V14.8387H11.8333V9.8387H14.6667ZM4.16668 3.8387V8.8387H1.33334V3.8387H4.16668ZM7.66668 3.8387V8.8387H4.83334V3.8387H7.66668ZM11.1667 3.8387V8.8387H8.33334V3.8387H11.1667ZM14.6667 3.8387V8.8387H11.8333V3.8387H14.6667ZM14.6667 1.50537V2.8387H1.33334V1.50537H14.6667Z"
      fill="currentColor"
    />
  </Icon>
);

export const Dollar: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11.8 10.9C9.53001 10.31 8.80001 9.7 8.80001 8.75C8.80001 7.66 9.81001 6.9 11.5 6.9C13.28 6.9 13.94 7.75 14 9H16.21C16.14 7.28 15.09 5.7 13 5.19V3H10V5.16C8.06001 5.58 6.50001 6.84 6.50001 8.77C6.50001 11.08 8.41001 12.23 11.2 12.9C13.7 13.5 14.2 14.38 14.2 15.31C14.2 16 13.71 17.1 11.5 17.1C9.44001 17.1 8.63001 16.18 8.52001 15H6.32001C6.44001 17.19 8.08001 18.42 10 18.83V21H13V18.85C14.95 18.48 16.5 17.35 16.5 15.3C16.5 12.46 14.07 11.49 11.8 10.9Z"
      fill="currentColor"
    />
  </Icon>
);

export const Download: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z"
      fill="currentColor"
    />
  </Icon>
);

export const Duplicate: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M17 7V2H2V17H7V22H22V7H17ZM3.66667 15.3333V3.66667H15.3333V7H7V15.3333H3.66667Z"
      fill="currentColor"
    />
  </Icon>
);

export const Email: IconProps = (props) => (
  <Icon viewBox="0 0 23 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 0H2C0.899994 0 0.00999451 0.9 0.00999451 2L0 14C0 15.1 0.899994 16 2 16H12.8027C12.2922 15.1175 12 14.0929 12 13C12 9.68629 14.6863 7 18 7C18.7013 7 19.3745 7.12031 20 7.34141V2C20 0.9 19.1 0 18 0ZM17.6 4.25L10.53 8.67C10.21 8.87 9.79001 8.87 9.47 8.67L2.39999 4.25C2.14999 4.09 2 3.82 2 3.53C2 2.86 2.73 2.46 3.3 2.81L10 7L16.7 2.81C17.27 2.46 18 2.86 18 3.53C18 3.82 17.85 4.09 17.6 4.25Z"
      fill="currentColor"
    />
    <path
      d="M15 13.2915H19.01V15.0915C19.01 15.5315 19.55 15.7615 19.86 15.4415L22.64 12.6515C22.83 12.4515 22.83 12.1415 22.64 11.9415L19.86 9.15153C19.55 8.83153 19.01 9.05153 19.01 9.50153V11.2915L15 11.2915C14.45 11.2915 14 11.7415 14 12.2915C14 12.8415 14.45 13.2915 15 13.2915Z"
      fill="currentColor"
    />
  </Icon>
);

export const EmailLog: IconProps = (props) => (
  <Icon width="16" height="17" viewBox="0 0 16 17" fill="none" {...props}>
    <path
      d="M12.6667 2.97852H3.33333C2.6 2.97852 2 3.57852 2 4.31185V13.6452C2 14.3785 2.6 14.9785 3.33333 14.9785H12.6667C13.4 14.9785 14 14.3785 14 13.6452V4.31185C14 3.57852 13.4 2.97852 12.6667 2.97852ZM9.33333 12.3118H4.66667V10.9785H9.33333V12.3118ZM11.3333 9.64518H4.66667V8.31185H11.3333V9.64518ZM11.3333 6.97852H4.66667V5.64518H11.3333V6.97852Z"
      fill="#63686C"
    />
  </Icon>
);

export const EmailServices: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      d="M18 0H2C0.899994 0 0.00999451 0.9 0.00999451 2L0 14C0 15.1 0.899994 16 2 16H12.8027C12.2922 15.1175 12 14.0929 12 13C12 9.68629 14.6863 7 18 7C18.7013 7 19.3745 7.12031 20 7.34141V2C20 0.9 19.1 0 18 0ZM17.6 4.25L10.53 8.67C10.21 8.87 9.79001 8.87 9.47 8.67L2.39999 4.25C2.14999 4.09 2 3.82 2 3.53C2 2.86 2.73 2.46 3.3 2.81L10 7L16.7 2.81C17.27 2.46 18 2.86 18 3.53C18 3.82 17.85 4.09 17.6 4.25Z"
    />
    <path
      fill="currentColor"
      d="M15 13.2915H19.01V15.0915C19.01 15.5315 19.55 15.7615 19.86 15.4415L22.64 12.6515C22.83 12.4515 22.83 12.1415 22.64 11.9415L19.86 9.15153C19.55 8.83153 19.01 9.05153 19.01 9.50153V11.2915L15 11.2915C14.45 11.2915 14 11.7415 14 12.2915C14 12.8415 14.45 13.2915 15 13.2915Z"
    />
  </Icon>
);

export const Emoji: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M4 20.12H20V4.12H4V20.12Z" />
  </Icon>
);

export const Empty: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 10.15 4.63 8.45 5.69 7.1L16.9 18.31C15.55 19.37 13.85 20 12 20ZM18.31 16.9L7.1 5.69C8.45 4.63 10.15 4 12 4C16.42 4 20 7.58 20 12C20 13.85 19.37 15.55 18.31 16.9Z"
      fill="currentColor"
    />
  </Icon>
);

export const ExternalLink: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z"
      fill="currentColor"
    />
  </Icon>
);

export const File: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM14 17H7V15H14V17ZM17 13H7V11H17V13ZM17 9H7V7H17V9Z"
      fill="currentColor"
    />
  </Icon>
);

export const Filter: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" fill="currentColor" />
  </Icon>
);

export const Fire: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19.48 12.35C17.91 8.27002 12.32 8.05002 13.67 2.12002C13.77 1.68002 13.3 1.34002 12.92 1.57002C9.29 3.71002 6.68 8.00002 8.87 13.62C9.05 14.08 8.51 14.51 8.12 14.21C6.31 12.84 6.12 10.87 6.28 9.46002C6.34 8.94002 5.66 8.69002 5.37 9.12002C4.69 10.16 4 11.84 4 14.37C4.38 19.97 9.11 21.69 10.81 21.91C13.24 22.22 15.87 21.77 17.76 20.04C19.84 18.11 20.6 15.03 19.48 12.35ZM10.2 17.38C11.64 17.03 12.38 15.99 12.58 15.07C12.91 13.64 11.62 12.24 12.49 9.98002C12.82 11.85 15.76 13.02 15.76 15.06C15.84 17.59 13.1 19.76 10.2 17.38Z"
      fill="currentColor"
    />
  </Icon>
);

export const FormatAlignCenter: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7 15V17H17V15H7ZM3 21H21V19H3V21ZM3 13H21V11H3V13ZM7 7V9H17V7H7ZM3 3V5H21V3H3Z"
      fill="currentColor"
    />
  </Icon>
);

export const FormatAlignJustify: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M3 21H21V19H3V21ZM3 17H21V15H3V17ZM3 13H21V11H3V13ZM3 9H21V7H3V9ZM3 3V5H21V3H3Z"
      fill="currentColor"
    />
  </Icon>
);

export const FormatAlignLeft: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M15 15H3V17H15V15ZM15 7H3V9H15V7ZM3 13H21V11H3V13ZM3 21H21V19H3V21ZM3 3V5H21V3H3Z"
      fill="currentColor"
    />
  </Icon>
);

export const FormatAlignRight: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M3 21H21V19H3V21ZM9 17H21V15H9V17ZM3 13H21V11H3V13ZM9 9H21V7H9V9ZM3 3V5H21V3H3Z"
      fill="currentColor"
    />
  </Icon>
);

export const FormatBold: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M15.6 10.79C16.57 10.12 17.25 9.02 17.25 8C17.25 5.74 15.5 4 13.25 4H7V18H14.04C16.13 18 17.75 16.3 17.75 14.21C17.75 12.69 16.89 11.39 15.6 10.79ZM10 6.5H13C13.83 6.5 14.5 7.17 14.5 8C14.5 8.83 13.83 9.5 13 9.5H10V6.5ZM13.5 15.5H10V12.5H13.5C14.33 12.5 15 13.17 15 14C15 14.83 14.33 15.5 13.5 15.5Z"
      fill="currentColor"
    />
  </Icon>
);

export const FormatItalic: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M10 4V7H12.21L8.79 15H6V18H14V15H11.79L15.21 7H18V4H10Z" fill="currentColor" />
  </Icon>
);

export const FormatListBullet: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M4 10.5C3.17 10.5 2.5 11.17 2.5 12C2.5 12.83 3.17 13.5 4 13.5C4.83 13.5 5.5 12.83 5.5 12C5.5 11.17 4.83 10.5 4 10.5ZM4 4.5C3.17 4.5 2.5 5.17 2.5 6C2.5 6.83 3.17 7.5 4 7.5C4.83 7.5 5.5 6.83 5.5 6C5.5 5.17 4.83 4.5 4 4.5ZM4 16.5C3.17 16.5 2.5 17.18 2.5 18C2.5 18.82 3.18 19.5 4 19.5C4.82 19.5 5.5 18.82 5.5 18C5.5 17.18 4.83 16.5 4 16.5ZM7 19H21V17H7V19ZM7 13H21V11H7V13ZM7 5V7H21V5H7Z"
      fill="currentColor"
    />
  </Icon>
);

export const FormatListNumber: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 17H4V17.5H3V18.5H4V19H2V20H5V16H2V17ZM3 8H4V4H2V5H3V8ZM2 11H3.8L2 13.1V14H5V13H3.2L5 10.9V10H2V11ZM7 5V7H21V5H7ZM7 19H21V17H7V19ZM7 13H21V11H7V13Z"
      fill="currentColor"
    />
  </Icon>
);

export const FormatTextColor: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 20H22V24H2V20ZM5.49 17H7.91L9.18 13.42H14.83L16.09 17H18.51L13.25 3H10.75L5.49 17ZM9.91 11.39L11.94 5.6H12.06L14.09 11.39H9.91Z"
      fill="currentColor"
    />
  </Icon>
);

export const FormatUnderline: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 17C15.31 17 18 14.31 18 11V3H15.5V11C15.5 12.93 13.93 14.5 12 14.5C10.07 14.5 8.5 12.93 8.5 11V3H6V11C6 14.31 8.69 17 12 17ZM5 19V21H19V19H5Z"
      fill="currentColor"
    />
  </Icon>
);

export const GroupView: IconProps = (props) => (
  <Icon viewBox="0 0 16 17" {...props}>
    <path
      d="M8.74075 7.50537V9.28285C7.98422 9.49469 7.60596 9.98862 7.60596 10.7646C7.60596 11.4323 7.98422 11.8979 8.74075 12.1615C6.95803 12.4354 6.03484 12.9511 5.97117 13.7088L5.96763 13.794V14.839L4.66668 14.8387V7.50537H8.74075ZM9.06668 12.5938C9.90839 12.5938 11.5663 13.0019 11.6796 13.8147L11.6857 13.9033V14.8387H6.44763V13.9033C6.44763 13.0316 8.19491 12.5938 9.06668 12.5938ZM12.0599 12.5938C12.9016 12.5938 14.5595 13.0019 14.6728 13.8147L14.6789 13.9033V14.8387H12.434V13.9033C12.434 13.3496 12.131 12.9268 11.6969 12.6125C11.8279 12.6013 11.9514 12.5938 12.0599 12.5938ZM4.16668 11.8387V14.8387H1.33334V11.8387H4.16668ZM6.29631 11.5794H5.48149V12.3943H6.29631V11.5794ZM12.0599 9.60061C12.681 9.60061 13.1786 10.102 13.1786 10.7231C13.1786 11.3441 12.681 11.8455 12.0599 11.8455C11.4388 11.8455 10.9374 11.3441 10.9374 10.7231C10.9374 10.102 11.4388 9.60061 12.0599 9.60061ZM9.06668 9.60061C9.68777 9.60061 10.1854 10.102 10.1854 10.7231C10.1854 11.3441 9.68777 11.8455 9.06668 11.8455C8.44559 11.8455 7.94423 11.3441 7.94423 10.7231C7.94423 10.102 8.44559 9.60061 9.06668 9.60061ZM4.16668 7.8387V10.8387H1.33334V7.8387H4.16668ZM6.29631 9.94982H5.48149V10.7646H6.29631V9.94982ZM6.29631 8.32019H5.48149V9.135H6.29631V8.32019ZM7.92594 8.32019H7.11112V9.135H7.92594V8.32019ZM4.16668 3.8387V6.8387H1.33334V3.8387H4.16668ZM7.66668 3.8387V6.8387H4.83334V3.8387H7.66668ZM11.1667 3.8387V6.8387H8.33334V3.8387H11.1667ZM14.6667 3.8387V6.8387H11.8333V3.8387H14.6667ZM14.6667 1.50537V2.8387H1.33334V1.50537H14.6667Z"
      fill="currentColor"
    />
  </Icon>
);

export const Help: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 9.88 15.64 10.68 15.07 11.25Z"
      fill="currentColor"
    />
  </Icon>
);

export const Image: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19ZM8.5 13.5L11 16.51L14.5 12L19 18H5L8.5 13.5Z"
      fill="currentColor"
    />
  </Icon>
);

export const InfoCircle: IconProps = (props) => (
  <Icon width="14" height="14" fill="none" viewBox="0 0 14 14" {...props}>
    <path
      d="M7.00004 0.333984C3.32004 0.333984 0.333374 3.32065 0.333374 7.00065C0.333374 10.6807 3.32004 13.6673 7.00004 13.6673C10.68 13.6673 13.6667 10.6807 13.6667 7.00065C13.6667 3.32065 10.68 0.333984 7.00004 0.333984ZM7.66671 10.334H6.33337V6.33398H7.66671V10.334ZM7.66671 5.00065H6.33337V3.66732H7.66671V5.00065Z"
      fill="currentColor"
    />
  </Icon>
);

export const Inventory: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19.2 3H4.8C3.9 3 3 3.81 3 4.8V7.509C3 8.157 3.387 8.715 3.9 9.03V19.2C3.9 20.19 4.89 21 5.7 21H18.3C19.11 21 20.1 20.19 20.1 19.2V9.03C20.613 8.715 21 8.157 21 7.509V4.8C21 3.81 20.1 3 19.2 3ZM14.7 13.8H9.3V12H14.7V13.8ZM19.2 7.5H4.8V4.8L19.2 4.782V7.5Z"
      fill="currentColor"
    />
  </Icon>
);

export const Links: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M3.9 12C3.9 10.29 5.29 8.9 7 8.9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15.1H7C5.29 15.1 3.9 13.71 3.9 12ZM8 13H16V11H8V13ZM17 7H13V8.9H17C18.71 8.9 20.1 10.29 20.1 12C20.1 13.71 18.71 15.1 17 15.1H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7Z"
      fill="currentColor"
    />
  </Icon>
);

export const Lock: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z"
      fill="currentColor"
    />
  </Icon>
);

export const Logout: IconProps = (props) => (
  <Icon viewBox="0 0 12 12" {...props}>
    <path
      d="M10.3334 2.66667L9.39337 3.60667L11.1134 5.33333H4.33337V6.66667H11.1134L9.39337 8.38667L10.3334 9.33333L13.6667 6L10.3334 2.66667ZM1.66671 1.33333H7.00004V0H1.66671C0.933374 0 0.333374 0.6 0.333374 1.33333V10.6667C0.333374 11.4 0.933374 12 1.66671 12H7.00004V10.6667H1.66671V1.33333Z"
      fill="#D62F1D"
    />
  </Icon>
);

export const Loyalty: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11.25 21H4.5V12H11.25V21ZM11.25 7.5H3V10.5H11.25V7.5ZM12.75 21H19.5V12H12.75V21ZM12.75 7.5V10.5H21V7.5H12.75ZM16.0267 3C13.8165 3 12.5235 5.60775 12 6.75H16.0087C18.6285 6.75 18.6562 3 16.0267 3ZM15.4298 5.71575H13.8975C14.4517 4.875 14.9767 4.24125 15.654 4.24125C16.533 4.24125 16.575 5.71575 15.4298 5.71575ZM7.99125 6.75H12C11.4765 5.60775 10.1835 3 7.97325 3C5.34375 3 5.3715 6.75 7.99125 6.75ZM8.346 4.24125C9.02325 4.24125 9.54825 4.875 10.1025 5.71575H8.57025C7.425 5.71575 7.467 4.24125 8.346 4.24125Z"
      fill="currentColor"
    />
  </Icon>
);

export const Minus: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M7 11V13H17V11H7Z" fill="currentColor" />
  </Icon>
);

export const MonthView: IconProps = (props) => (
  <Icon viewBox="0 0 16 17" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.33334 1.50537H14.6667V2.8387H1.33334V1.50537ZM1.33334 3.8387H3.46668V6.8387H1.33334V3.8387ZM4.13334 3.8387H6.26667V6.8387H4.13334V3.8387ZM9.06668 3.8387H6.93334V6.8387H9.06668V3.8387ZM9.73334 3.8387H11.8667V6.8387H9.73334V3.8387ZM14.6667 3.8387H12.5333V6.8387H14.6667V3.8387ZM1.33334 7.8387H3.46668V10.8387H1.33334V7.8387ZM6.26667 7.8387H4.13334V10.8387H6.26667V7.8387ZM6.93334 7.8387H9.06668V10.8387H6.93334V7.8387ZM11.8667 7.8387H9.73334V10.8387H11.8667V7.8387ZM12.5333 7.8387H14.6667V10.8387H12.5333V7.8387ZM3.46668 11.8387H1.33334V14.8387H3.46668V11.8387ZM4.13334 11.8387H6.26667V14.8387H4.13334V11.8387ZM9.06668 11.8387H6.93334V14.8387H9.06668V11.8387ZM9.73334 11.8387H11.8667V14.8387H9.73334V11.8387ZM14.6667 11.8387H12.5333V14.8387H14.6667V11.8387Z"
      fill="currentColor"
    />
  </Icon>
);

export const MoreHorizontal: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
      fill="currentColor"
    />
  </Icon>
);

export const NightlyRatesView: IconProps = (props) => (
  <Icon viewBox="0 0 16 17" {...props}>
    <path
      d="M10.2667 7.50537V8.2387H11.7333V9.70537H8.80001V10.4387H11C11.4033 10.4387 11.7333 10.7687 11.7333 11.172V13.372C11.7333 13.7754 11.4033 14.1054 11 14.1054H10.2667V14.8387H8.80001V14.1054H7.33334V12.6387H10.2667V11.9054H8.06668C7.66334 11.9054 7.33334 11.5754 7.33334 11.172V8.97204C7.33334 8.5687 7.66334 8.2387 8.06668 8.2387H8.80001V7.50537H10.2667ZM4.16668 11.8387V14.8387H1.33334V11.8387H4.16668ZM4.16668 7.8387V10.8387H1.33334V7.8387H4.16668ZM4.16668 3.8387V6.8387H1.33334V3.8387H4.16668ZM7.66668 3.8387V6.8387H4.83334V3.8387H7.66668ZM11.1667 3.8387V6.8387H8.33334V3.8387H11.1667ZM14.6667 3.8387V6.8387H11.8333V3.8387H14.6667ZM14.6667 1.50537V2.8387H1.33334V1.50537H14.6667Z"
      fill="currentColor"
    />
  </Icon>
);

export const NormalView: IconProps = (props) => (
  <Icon viewBox="0 0 16 17" {...props}>
    <path
      d="M4.16668 11.8387V14.8387H1.33334V11.8387H4.16668ZM7.66668 11.8387V14.8387H4.83334V11.8387H7.66668ZM11.1667 11.8387V14.8387H8.33334V11.8387H11.1667ZM14.6667 11.8387V14.8387H11.8333V11.8387H14.6667ZM4.16668 7.8387V10.8387H1.33334V7.8387H4.16668ZM7.66668 7.8387V10.8387H4.83334V7.8387H7.66668ZM11.1667 7.8387V10.8387H8.33334V7.8387H11.1667ZM14.6667 7.8387V10.8387H11.8333V7.8387H14.6667ZM4.16668 3.8387V6.8387H1.33334V3.8387H4.16668ZM7.66668 3.8387V6.8387H4.83334V3.8387H7.66668ZM11.1667 3.8387V6.8387H8.33334V3.8387H11.1667ZM14.6667 3.8387V6.8387H11.8333V3.8387H14.6667ZM14.6667 1.50537V2.8387H1.33334V1.50537H14.6667Z"
      fill="currentColor"
    />
  </Icon>
);

export const Palette: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C13.38 22 14.5 20.88 14.5 19.5C14.5 18.89 14.27 18.3 13.86 17.83C13.78 17.73 13.73 17.62 13.73 17.5C13.73 17.22 13.95 17 14.23 17H16C19.31 17 22 14.31 22 11C22 6.04 17.51 2 12 2ZM17.5 13C16.67 13 16 12.33 16 11.5C16 10.67 16.67 10 17.5 10C18.33 10 19 10.67 19 11.5C19 12.33 18.33 13 17.5 13ZM14.5 9C13.67 9 13 8.33 13 7.5C13 6.67 13.67 6 14.5 6C15.33 6 16 6.67 16 7.5C16 8.33 15.33 9 14.5 9ZM5 11.5C5 10.67 5.67 10 6.5 10C7.33 10 8 10.67 8 11.5C8 12.33 7.33 13 6.5 13C5.67 13 5 12.33 5 11.5ZM11 7.5C11 8.33 10.33 9 9.5 9C8.67 9 8 8.33 8 7.5C8 6.67 8.67 6 9.5 6C10.33 6 11 6.67 11 7.5Z"
      fill="currentColor"
    />
  </Icon>
);

export const Password: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12.65 10C11.83 7.67 9.61 6 7 6C3.69 6 1 8.69 1 12C1 15.31 3.69 18 7 18C9.61 18 11.83 16.33 12.65 14H17V18H21V14H23V10H12.65ZM7 14C5.9 14 5 13.1 5 12C5 10.9 5.9 10 7 10C8.1 10 9 10.9 9 12C9 13.1 8.1 14 7 14Z"
      fill="currentColor"
    />
  </Icon>
);

export const Pin: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8 10.6V6.6H15.6C16.04 6.6 16.4 6.24 16.4 5.8C16.4 5.36 16.04 5 15.6 5H7.6C7.16 5 6.8 5.36 6.8 5.8C6.8 6.24 7.16 6.6 7.6 6.6H8.4V10.6C8.4 11.928 7.328 13 6 13V14.6H10.776V20.2L11.576 21L12.376 20.2V14.6H17.2V13C15.872 13 14.8 11.928 14.8 10.6Z"
      fill="currentColor"
    />
  </Icon>
);

export const Print: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19 8H5C3.34 8 2 9.34 2 11V17H6V21H18V17H22V11C22 9.34 20.66 8 19 8ZM16 19H8V14H16V19ZM19 12C18.45 12 18 11.55 18 11C18 10.45 18.45 10 19 10C19.55 10 20 10.45 20 11C20 11.55 19.55 12 19 12ZM18 3H6V7H18V3Z"
      fill="currentColor"
    />
  </Icon>
);

export const Progress: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 12C22 14.1277 21.3213 16.2 20.0626 17.9156C18.804 19.6311 17.0309 20.9004 15.0012 21.539C12.9716 22.1776 10.7912 22.1521 8.77695 21.4664C6.76275 20.7806 5.01979 19.4702 3.8015 17.7258C2.5832 15.9813 1.95307 13.8938 2.00272 11.7666C2.05238 9.63945 2.77924 7.58358 4.07761 5.89789C5.37598 4.21221 7.17818 2.9846 9.22219 2.39355C11.2662 1.80251 13.4454 1.87884 15.4431 2.61144L14.4843 5.22574C13.043 4.69714 11.4705 4.64207 9.99569 5.06853C8.52085 5.495 7.22048 6.38077 6.28365 7.59706C5.34682 8.81336 4.82236 10.2968 4.78653 11.8316C4.7507 13.3664 5.20537 14.8727 6.08442 16.1314C6.96348 17.3901 8.2211 18.3356 9.67443 18.8304C11.1278 19.3252 12.701 19.3436 14.1655 18.8828C15.63 18.422 16.9094 17.5062 17.8175 16.2683C18.7257 15.0305 19.2154 13.5353 19.2154 12H22Z"
      fill="currentColor"
    />
  </Icon>
);

export const QuarterView: IconProps = (props) => (
  <Icon viewBox="0 0 16 17" {...props}>
    <path
      d="M4.15934 13.7587V14.8387H3.07934V13.7587H4.15934ZM5.90601 13.7587V14.8387H4.82601V13.7587H5.90601ZM7.65268 13.7587V14.8387H6.57268V13.7587H7.65268ZM9.39934 13.7587V14.8387H8.31934V13.7587H9.39934ZM11.146 13.7587V14.8387H10.066V13.7587H11.146ZM12.8927 13.7587V14.8387H11.8127V13.7587H12.8927ZM14.6667 13.7587V14.8387H13.5867V13.7587H14.6667ZM2.41268 13.7587V14.838H1.33334V13.7587H2.41268ZM4.15934 11.7587V12.8387H3.07934V11.7587H4.15934ZM5.90601 11.7587V12.8387H4.82601V11.7587H5.90601ZM7.65268 11.7587V12.8387H6.57268V11.7587H7.65268ZM9.39934 11.7587V12.8387H8.31934V11.7587H9.39934ZM11.146 11.7587V12.8387H10.066V11.7587H11.146ZM12.8927 11.7587V12.8387H11.8127V11.7587H12.8927ZM14.6667 11.7587V12.8387H13.5867V11.7587H14.6667ZM2.41268 11.7587V12.838H1.33334V11.7587H2.41268ZM7.65268 9.7787V10.8587H6.57268V9.7787H7.65268ZM9.39934 9.7787V10.8587H8.31934V9.7787H9.39934ZM11.146 9.7787V10.8587H10.066V9.7787H11.146ZM12.8927 9.7787V10.8587H11.8127V9.7787H12.8927ZM14.6667 9.7787V10.8587H13.5867V9.7787H14.6667ZM4.15934 9.7787V10.8587H3.07934V9.7787H4.15934ZM5.90601 9.7787V10.8587H4.82601V9.7787H5.90601ZM2.41268 9.7787V10.858H1.33334V9.7787H2.41268ZM11.146 7.7987V8.8787H10.066V7.7987H11.146ZM12.8927 7.7987V8.8787H11.8127V7.7987H12.8927ZM14.6667 7.7987V8.8787H13.5867V7.7987H14.6667ZM7.65268 7.7987V8.8787H6.57268V7.7987H7.65268ZM9.39934 7.7987V8.8787H8.31934V7.7987H9.39934ZM4.15934 7.7987V8.8787H3.07934V7.7987H4.15934ZM5.90601 7.7987V8.8787H4.82601V7.7987H5.90601ZM2.41268 7.7987V8.87804H1.33334V7.7987H2.41268ZM5.90601 5.8187V6.8987H4.82601V5.8187H5.90601ZM7.65268 5.8187V6.8987H6.57268V5.8187H7.65268ZM4.15934 5.8187V6.8987H3.07934V5.8187H4.15934ZM9.39934 5.8187V6.8987H8.31934V5.8187H9.39934ZM12.8927 5.8187V6.8987H11.8127V5.8187H12.8927ZM11.146 5.8187V6.8987H10.066V5.8187H11.146ZM14.6667 5.8187V6.8987H13.5867V5.8187H14.6667ZM2.41268 5.8187V6.89804H1.33334V5.8187H2.41268ZM4.15934 3.8387V4.9187H3.07934V3.8387H4.15934ZM5.90601 3.8387V4.9187H4.82601V3.8387H5.90601ZM7.65268 3.8387V4.9187H6.57268V3.8387H7.65268ZM9.39934 3.8387V4.9187H8.31934V3.8387H9.39934ZM11.146 3.8387V4.9187H10.066V3.8387H11.146ZM12.8927 3.8387V4.9187H11.8127V3.8387H12.8927ZM14.6667 3.8387V4.9187H13.5867V3.8387H14.6667ZM2.41268 3.8387V4.91804H1.33334V3.8387H2.41268ZM14.6667 1.50537V2.8387H1.33334V1.50537H14.6667Z"
      fill="currentColor"
    />
  </Icon>
);

export const Reverse: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11.7273 5.45455V8.72727L16.0909 4.36364L11.7273 0V3.27273C6.90545 3.27273 3 7.17818 3 12C3 13.7127 3.50182 15.3055 4.35273 16.6473L5.94545 15.0545C5.45455 14.1491 5.18182 13.1018 5.18182 12C5.18182 8.38909 8.11636 5.45455 11.7273 5.45455ZM19.1018 7.35273L17.5091 8.94545C17.9891 9.86182 18.2727 10.8982 18.2727 12C18.2727 15.6109 15.3382 18.5455 11.7273 18.5455V15.2727L7.36364 19.6364L11.7273 24V20.7273C16.5491 20.7273 20.4545 16.8218 20.4545 12C20.4545 10.2873 19.9527 8.69455 19.1018 7.35273Z"
      fill="currentColor"
    />
  </Icon>
);

export const RoomAvailabilities: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19.41 10.42L17.99 9L14.82 12.17L13.41 10.75L12 12.16L14.82 15L19.41 10.42Z"
      fill="currentColor"
    />
    <path d="M5 7H10V9H5V7Z" fill="currentColor" />
    <path d="M10 11H5V13H10V11Z" fill="currentColor" />
    <path d="M5 15H10V17H5V15Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3ZM4 19V5H20V19H4Z"
      fill="currentColor"
    />
  </Icon>
);

export const RowCondense: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22.906 8.51567L21.7584 7.35614L20.709 8.41645V3H19.0858V8.41645L18.0365 7.35614L16.8889 8.51567L19.8974 11.5556L22.906 8.51567Z"
      fill="currentColor"
    />
    <path
      d="M16.8889 15.1596L18.0544 16.068L19.1202 15.2373V20.1112H20.7687V15.2373L21.8345 16.068L23 15.1596L19.9444 12.7779L16.8889 15.1596Z"
      fill="currentColor"
    />
    <path
      d="M1.275 3.00002H15.3917C15.5436 3.00002 15.6667 3.12314 15.6667 3.27502V12.5028C15.6667 12.6547 15.5436 12.7778 15.3917 12.7778H1.275C1.12312 12.7778 1 12.6547 1 12.5028V3.27502C1 3.12314 1.12312 3.00002 1.275 3.00002Z"
      fill="currentColor"
    />
    <path
      d="M15.3917 14.0314H1.275C1.12312 14.0314 1 14.1545 1 14.3064V16.2008C1 16.3527 1.12312 16.4758 1.275 16.4758H15.3917C15.5436 16.4758 15.6667 16.3527 15.6667 16.2008V14.3064C15.6667 14.1545 15.5436 14.0314 15.3917 14.0314Z"
      fill="currentColor"
    />
    <path
      d="M1.275 17.6667H15.3917C15.5436 17.6667 15.6667 17.7898 15.6667 17.9417V19.8361C15.6667 19.988 15.5436 20.1111 15.3917 20.1111H1.275C1.12312 20.1111 1 19.988 1 19.8361V17.9417C1 17.7898 1.12312 17.6667 1.275 17.6667Z"
      fill="currentColor"
    />
  </Icon>
);

export const ScrollDown: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12.7932 11.813L19.1131 5.30323C19.4005 5.00713 19.3935 4.53407 19.0974 4.24661L18.0308 3.2111C17.735 2.92392 17.2625 2.93058 16.9749 3.22599L12.2101 8.12032L7.30248 3.36917C7.00628 3.0824 6.53378 3.08973 6.2466 3.38553L5.2111 4.45216C4.92364 4.74826 4.93064 5.22133 5.22674 5.50879L11.7365 11.8287C12.0326 12.1161 12.5057 12.1091 12.7932 11.813Z"
      fill="currentColor"
    />
    <path
      d="M12.9258 20.7733L19.2457 14.2635C19.5332 13.9674 19.5262 13.4943 19.2301 13.2068L18.1634 12.1713C17.8676 11.8841 17.3951 11.8908 17.1075 12.1862L12.3427 17.0805L7.43512 12.3294C7.13891 12.0426 6.66641 12.0499 6.37924 12.3458L5.34373 13.4124C5.05627 13.7085 5.06327 14.1815 5.35937 14.469L11.8692 20.7889C12.1653 21.0764 12.6383 21.0694 12.9258 20.7733Z"
      fill="currentColor"
    />
  </Icon>
);

export const ScrollUp: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12.7932 12.187L19.1131 18.6968C19.4005 18.9929 19.3935 19.4659 19.0974 19.7534L18.0308 20.7889C17.735 21.0761 17.2625 21.0694 16.9749 20.774L12.2101 15.8797L7.30248 20.6308C7.00628 20.9176 6.53378 20.9103 6.2466 20.6145L5.2111 19.5478C4.92364 19.2517 4.93064 18.7787 5.22674 18.4912L11.7365 12.1713C12.0326 11.8839 12.5057 11.8909 12.7932 12.187Z"
      fill="currentColor"
    />
    <path
      d="M12.9258 3.22674L19.2457 9.73655C19.5332 10.0326 19.5262 10.5057 19.2301 10.7932L18.1634 11.8287C17.8676 12.1159 17.3951 12.1092 17.1075 11.8138L12.3427 6.91946L7.43512 11.6706C7.13891 11.9574 6.66641 11.9501 6.37924 11.6542L5.34373 10.5876C5.05627 10.2915 5.06327 9.81846 5.35937 9.531L11.8692 3.2111C12.1653 2.92364 12.6383 2.93064 12.9258 3.22674Z"
      fill="currentColor"
    />
  </Icon>
);

export const Search: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8055 17.8775C14.4875 18.7906 12.8876 19.3255 11.1628 19.3255C6.6546 19.3255 3 15.6709 3 11.1628C3 6.6546 6.6546 3 11.1628 3C15.6709 3 19.3255 6.6546 19.3255 11.1628C19.3255 12.8876 18.7906 14.4874 17.8775 15.8055L20.5709 18.4988C21.143 19.071 21.143 19.9987 20.5709 20.5708C19.9987 21.143 19.0711 21.143 18.4989 20.5708L15.8055 17.8775ZM5.93023 11.1628C5.93023 8.27292 8.27292 5.93023 11.1628 5.93023C14.0526 5.93023 16.3953 8.27292 16.3953 11.1628C16.3953 12.5585 15.8489 13.8266 14.9582 14.7647C14.9234 14.7936 14.8897 14.8244 14.857 14.857C14.8244 14.8896 14.7937 14.9234 14.7648 14.9582C13.8266 15.8488 12.5585 16.3953 11.1628 16.3953C8.27292 16.3953 5.93023 14.0526 5.93023 11.1628Z"
      fill="currentColor"
    />
  </Icon>
);

export const SendFeedback: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16 7V9L20 9V7L16 7ZM14 13.61C14.96 14.32 16.21 15.26 17.2 16C17.6 15.47 18 14.93 18.4 14.4C17.41 13.66 16.16 12.72 15.2 12C14.8 12.54 14.4 13.08 14 13.61ZM18.4 1.6C18 1.07 17.6 0.53 17.2 0C16.21 0.74 14.96 1.68 14 2.4C14.4 2.93 14.8 3.47 15.2 4C16.16 3.28 17.41 2.35 18.4 1.6ZM2 5C0.9 5 0 5.9 0 7L0 9C0 10.1 0.9 11 2 11H3L3 15H5L5 11L6 11L11 14L11 2L6 5L2 5ZM13.5 8C13.5 6.67 12.92 5.47 12 4.65L12 11.34C12.92 10.53 13.5 9.33 13.5 8Z"
      fill="currentColor"
    />
  </Icon>
);

export const Sort: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12.5 6.83L16.2985 10L17.988 8.59L12.5 4L7 8.59L8.70153 10L12.5 6.83ZM12.5 17.17L8.70153 14L7.01198 15.41L12.5 20L18 15.41L16.2985 14L12.5 17.17Z"
      fill="currentColor"
    />
  </Icon>
);

export const SortDown: IconProps = (props) => (
  <Icon viewBox="0 0 11 6" {...props}>
    <path
      d="M1.68954 0L5.48802 3.17L9.28649 0L10.988 1.41L5.48802 6L0 1.41L1.68954 0Z"
      fill="currentColor"
    />
  </Icon>
);

export const SortUp: IconProps = (props) => (
  <Icon viewBox="0 0 11 6" {...props}>
    <path
      d="M5.5 2.83L9.29848 6L10.988 4.59L5.5 0L0 4.59L1.70153 6L5.5 2.83Z"
      fill="currentColor"
    />
  </Icon>
);

export const Split: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18.7 4.1V9.35H6.1V4.1H18.7ZM18.7 2H6.1C4.945 2 4 2.945 4 4.1V9.35C4 10.505 4.945 11.45 6.1 11.45H18.7C19.855 11.45 20.8 10.505 20.8 9.35V4.1C20.8 2.945 19.855 2 18.7 2ZM18.7 15.65V20.9H6.1V15.65H18.7ZM18.7 13.55H6.1C4.945 13.55 4 14.495 4 15.65V20.9C4 22.055 4.945 23 6.1 23H18.7C19.855 23 20.8 22.055 20.8 20.9V15.65C20.8 14.495 19.855 13.55 18.7 13.55Z"
      fill="currentColor"
    />
  </Icon>
);

export const Star: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z"
      fill="currentColor"
    />
  </Icon>
);

export const SetOfStars: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16.3636 7.27273L17.5 4.77273L20 3.63636L17.5 2.5L16.3636 0L15.2273 2.5L12.7273 3.63636L15.2273 4.77273L16.3636 7.27273ZM9.54545 7.72727L7.27273 2.72727L5 7.72727L0 10L5 12.2727L7.27273 17.2727L9.54545 12.2727L14.5455 10L9.54545 7.72727ZM16.3636 12.7273L15.2273 15.2273L12.7273 16.3636L15.2273 17.5L16.3636 20L17.5 17.5L20 16.3636L17.5 15.2273L16.3636 12.7273Z"
      fill="white"
    />
  </Icon>
);

export const Stop: IconProps = (props) => (
  <Icon viewBox="0 0 18 18" {...props}>
    <path
      d="M9.00008 0.616821C4.40008 0.616821 0.666748 4.35015 0.666748 8.95016C0.666748 13.5502 4.40008 17.2835 9.00008 17.2835C13.6001 17.2835 17.3334 13.5502 17.3334 8.95016C17.3334 4.35015 13.6001 0.616821 9.00008 0.616821ZM9.00008 15.6168C5.31675 15.6168 2.33341 12.6335 2.33341 8.95016C2.33341 7.40849 2.85841 5.99182 3.74175 4.86682L13.0834 14.2085C11.9584 15.0918 10.5417 15.6168 9.00008 15.6168ZM14.2584 13.0335L4.91675 3.69182C6.04175 2.80849 7.45842 2.28349 9.00008 2.28349C12.6834 2.28349 15.6667 5.26682 15.6667 8.95016C15.6667 10.4918 15.1417 11.9085 14.2584 13.0335Z"
      fill="currentColor"
    />
  </Icon>
);

export const Switch: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M14.2366 12.0605L15.176 13H11.5C11.2239 13 11 13.2239 11 13.5V14.5C11 14.7761 11.2239 15 11.5 15H15.176L14.2367 15.9386C14.0414 16.1337 14.0413 16.4503 14.2365 16.6456L14.9436 17.3533C15.1387 17.5487 15.4552 17.5488 15.6506 17.3535L18.6504 14.3535C18.8457 14.1582 18.8457 13.8417 18.6504 13.6464L15.6505 10.6455C15.4554 10.4501 15.1389 10.4501 14.9434 10.6455L14.2365 11.3533C14.0414 11.5487 14.0415 11.8652 14.2366 12.0605Z"
      fill="currentColor"
    />
    <path
      d="M8.828 11L9.76733 11.9386C9.96265 12.1338 9.96277 12.4503 9.76758 12.6456L9.06055 13.3534C8.86511 13.5488 8.54858 13.5488 8.35339 13.3534L5.35364 10.3535C5.15833 10.1582 5.15833 9.84167 5.35352 9.64636L8.35327 6.64539C8.54883 6.45007 8.86536 6.4502 9.06042 6.64563L9.76746 7.35339C9.96265 7.54871 9.96252 7.86523 9.76746 8.06055L8.828 9H12.5C12.7761 9 13 9.22388 13 9.5V10.5C13 10.7761 12.7761 11 12.5 11H8.828Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C6.48608 2 2 6.48608 2 12C2 17.5139 6.48608 22 12 22C17.5139 22 22 17.5139 22 12C22 6.48608 17.5139 2 12 2ZM12 4C7.58887 4 4 7.58887 4 12C4 16.4111 7.58887 20 12 20C16.4111 20 20 16.4111 20 12C20 7.58887 16.4111 4 12 4Z"
      fill="currentColor"
    />
  </Icon>
);

export const Template: IconProps = (props) => (
  <Icon viewBox="0 0 12 12" {...props}>
    <path
      d="M10.6667 0H1.33333C0.6 0 0 0.6 0 1.33333V10.6667C0 11.4 0.6 12 1.33333 12H10.6667C11.4 12 12 11.4 12 10.6667V1.33333C12 0.6 11.4 0 10.6667 0ZM7.33333 9.33333H2.66667V8H7.33333V9.33333ZM9.33333 6.66667H2.66667V5.33333H9.33333V6.66667ZM9.33333 4H2.66667V2.66667H9.33333V4Z"
      fill="currentColor"
    />
  </Icon>
);

export const ToggleOff: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16.5834 5.59766H7.41661C3.87924 5.59766 1 8.47606 1 12.0143C1 15.5526 3.87924 18.431 7.41661 18.431H16.5834C20.1208 18.431 23 15.5526 23 12.0143C23 8.47606 20.1208 5.59766 16.5834 5.59766V5.59766ZM7.41661 15.681C5.39456 15.681 3.75 14.0365 3.75 12.0143C3.75 9.99222 5.39456 8.34766 7.41661 8.34766C9.43883 8.34766 11.0834 9.99222 11.0834 12.0143C11.0834 14.0365 9.43883 15.681 7.41661 15.681Z"
      fill="currentColor"
    />
  </Icon>
);

export const ToggleOn: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7.41661 5.59766H16.5834C20.1208 5.59766 23 8.47606 23 12.0143C23 15.5526 20.1208 18.431 16.5834 18.431H7.41661C3.87924 18.431 1 15.5526 1 12.0143C1 8.47606 3.87924 5.59766 7.41661 5.59766ZM16.5834 15.681C18.6054 15.681 20.25 14.0365 20.25 12.0143C20.25 9.99222 18.6054 8.34766 16.5834 8.34766C14.5612 8.34766 12.9166 9.99222 12.9166 12.0143C12.9166 14.0365 14.5612 15.681 16.5834 15.681Z"
      fill="currentColor"
    />
  </Icon>
);

export const Trash: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M6 21H18V7H6V21ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z" fill="currentColor" />
  </Icon>
);

export const Undo: IconProps = (props) => (
  <Icon viewBox="0 0 1792 1792" {...props}>
    <path d="M1664 896q0 156-61 298t-164 245-245 164-298 61q-172 0-327-72.5t-264-204.5q-7-10-6.5-22.5t8.5-20.5l137-138q10-9 25-9 16 2 23 12 73 95 179 147t225 52q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5q-98 0-188 35.5t-160 101.5l137 138q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l130 129q107-101 244.5-156.5t284.5-55.5q156 0 298 61t245 164 164 245 61 298z" />
  </Icon>
);

export const Unlink: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M14.39 11L16 12.61V11H14.39ZM17 6.99999H13V8.89999H17C18.71 8.89999 20.1 10.29 20.1 12C20.1 13.27 19.33 14.37 18.23 14.84L19.63 16.24C21.05 15.36 22 13.79 22 12C22 9.23999 19.76 6.99999 17 6.99999ZM2 4.26999L5.11 7.37999C3.29 8.11999 2 9.90999 2 12C2 14.76 4.24 17 7 17H11V15.1H7C5.29 15.1 3.9 13.71 3.9 12C3.9 10.41 5.11 9.09999 6.66 8.92999L8.73 11H8V13H10.73L13 15.27V17H14.73L18.74 21.01L20.15 19.6L3.41 2.85999L2 4.26999Z"
      fill="currentColor"
    />
  </Icon>
);

export const Upload: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM7 9L8.41 10.41L11 7.83V16H13V7.83L15.59 10.41L17 9L12 4L7 9Z"
      fill="currentColor"
    />
  </Icon>
);

export const View: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M6.21053 5H3.05263C2.47368 5 2 5.47368 2 6.05263V18.6842C2 19.2632 2.47368 19.7368 3.05263 19.7368H6.21053C6.78947 19.7368 7.26316 19.2632 7.26316 18.6842V6.05263C7.26316 5.47368 6.78947 5 6.21053 5ZM20.9474 5H17.7895C17.2105 5 16.7368 5.47368 16.7368 6.05263V18.6842C16.7368 19.2632 17.2105 19.7368 17.7895 19.7368H20.9474C21.5263 19.7368 22 19.2632 22 18.6842V6.05263C22 5.47368 21.5263 5 20.9474 5ZM13.5789 5H10.4211C9.84211 5 9.36842 5.47368 9.36842 6.05263V18.6842C9.36842 19.2632 9.84211 19.7368 10.4211 19.7368H13.5789C14.1579 19.7368 14.6316 19.2632 14.6316 18.6842V6.05263C14.6316 5.47368 14.1579 5 13.5789 5Z"
      fill="currentColor"
    />
  </Icon>
);

export const Warning: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z" fill="currentColor" />
  </Icon>
);

export const ViewInput: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z"
      fill="currentColor"
    />
  </Icon>
);

export const Preview: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM19 19H5V7H19V19ZM12 10.5C13.84 10.5 15.48 11.46 16.34 13C15.48 14.54 13.84 15.5 12 15.5C10.16 15.5 8.52 14.54 7.66 13C8.52 11.46 10.16 10.5 12 10.5ZM12 9C9.27 9 6.94 10.66 6 13C6.94 15.34 9.27 17 12 17C14.73 17 17.06 15.34 18 13C17.06 10.66 14.73 9 12 9ZM12 14.5C11.17 14.5 10.5 13.83 10.5 13C10.5 12.17 11.17 11.5 12 11.5C12.83 11.5 13.5 12.17 13.5 13C13.5 13.83 12.83 14.5 12 14.5Z"
      fill="currentColor"
    />
  </Icon>
);

export const Refresh: IconProps = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM6 12.74C6.12 15.83 8.67 18.38 11.76 18.5C14.77 18.62 17.32 16.51 17.88 13.68C17.9667 13.2733 18.0082 13.0275 18.0047 12.9425L15.9913 13.0571C15.9816 13.0413 15.9578 13.1223 15.92 13.3C15.5 15.37 13.48 16.87 11.2 16.42C9.64 16.12 8.38 14.86 8.08 13.3C7.58 10.74 9.53 8.5 12 8.5L12.0002 9.90619C12.0002 10.0134 12.0002 10.2591 12 10.6432C12.6683 10.1756 13.014 9.92993 13.037 9.90619L15.65 7.82938C15.7435 7.73587 15.9852 7.58026 15.9913 7.46114C15.9982 7.32549 15.7565 7.19502 15.65 7.08853L12.6921 4.52671C12.5935 4.43127 12.3628 4.25107 12 3.9861C12 4.29423 12 4.52901 12 4.69047V6.5C8.61 6.5 5.87 9.32 6 12.74Z"
      fill="currentColor"
    />
  </Icon>
);

export const SendText: IconProps = (props) => (
  <Icon viewBox="0 0 14 20" {...props}>
    <path
      d="M11.5454 0.0090909L2.45453 0C1.45453 0 0.636353 0.818182 0.636353 1.81818V18.1818C0.636353 19.1818 1.45453 20 2.45453 20H11.5454C12.5454 20 13.3636 19.1818 13.3636 18.1818V1.81818C13.3636 0.818182 12.5454 0.0090909 11.5454 0.0090909ZM11.5454 16.3636H2.45453V3.63636H11.5454V16.3636Z"
      fill="currentColor"
    />
  </Icon>
);

export const NoShow: IconProps = (props) => (
  <Icon viewBox="0 0 20 20" {...props}>
    <path
      d="M7.46667 3.38838C8.14798 2.33283 9.33788 1.64192 10.6813 1.64192C12.802 1.64192 14.5197 3.3596 14.5197 5.4803C14.5197 6.82374 13.8288 8.01364 12.7732 8.69495L7.46667 3.38838ZM18.3581 14.2798C18.3389 13.2242 17.7535 12.255 16.8131 11.7657C16.2949 11.497 15.7288 11.2475 15.1146 11.0364L18.3581 14.2798ZM19.5 18.1374L1.86263 0.5L0.5 1.85303L9.03081 10.3838C7.29394 10.6045 5.77778 11.1419 4.5495 11.7753C3.5899 12.2646 3.00455 13.253 3.00455 14.3278V16.9955H15.6424L18.147 19.5L19.5 18.1374Z"
      fill="currentColor"
    />
  </Icon>
);

export const Group: IconProps = (props) => (
  <Icon viewBox="0 0 22 14" {...props}>
    <path
      d="M15 6C16.66 6 17.99 4.66 17.99 3C17.99 1.34 16.66 0 15 0C13.34 0 12 1.34 12 3C12 4.66 13.34 6 15 6ZM7 6C8.66 6 9.99 4.66 9.99 3C9.99 1.34 8.66 0 7 0C5.34 0 4 1.34 4 3C4 4.66 5.34 6 7 6ZM7 8C4.67 8 0 9.17 0 11.5V14H14V11.5C14 9.17 9.33 8 7 8ZM15 8C14.71 8 14.38 8.02 14.03 8.05C15.19 8.89 16 10.02 16 11.5V14H22V11.5C22 9.17 17.33 8 15 8Z"
      fill="currentColor"
    />
  </Icon>
);

export const Company: IconProps = (props) => (
  <Icon viewBox="0 0 20 18" {...props}>
    <path
      d="M10 4.25001V0.450012H0.5V17.55H19.5V4.25001H10ZM4.3 15.65H2.4V13.75H4.3V15.65ZM4.3 11.85H2.4V9.95001H4.3V11.85ZM4.3 8.05001H2.4V6.15001H4.3V8.05001ZM4.3 4.25001H2.4V2.35001H4.3V4.25001ZM8.1 15.65H6.2V13.75H8.1V15.65ZM8.1 11.85H6.2V9.95001H8.1V11.85ZM8.1 8.05001H6.2V6.15001H8.1V8.05001ZM8.1 4.25001H6.2V2.35001H8.1V4.25001ZM17.6 15.65H10V13.75H11.9V11.85H10V9.95001H11.9V8.05001H10V6.15001H17.6V15.65ZM15.7 8.05001H13.8V9.95001H15.7V8.05001ZM15.7 11.85H13.8V13.75H15.7V11.85Z"
      fill="currentColor"
    />
  </Icon>
);

export const Profile: IconProps = (props) => (
  <Icon viewBox="0 0 18 18" {...props}>
    <path
      d="M9 9C11.4862 9 13.5 6.98625 13.5 4.5C13.5 2.01375 11.4862 0 9 0C6.51375 0 4.5 2.01375 4.5 4.5C4.5 6.98625 6.51375 9 9 9ZM9 11.25C5.99625 11.25 0 12.7575 0 15.75V18H18V15.75C18 12.7575 12.0037 11.25 9 11.25Z"
      fill="currentColor"
    />
  </Icon>
);

export const ArrowLeftRight: IconProps = (props) => (
  <Icon viewBox="0 0 13.33 13.33" {...props}>
    <path
      d="M13.6667 7.00065C13.6667 3.32065 10.68 0.333984 7.00004 0.333984C3.32004 0.333984 0.333374 3.32065 0.333374 7.00065C0.333374 10.6807 3.32004 13.6673 7.00004 13.6673C10.68 13.6673 13.6667 10.6807 13.6667 7.00065ZM9.00004 3.33398L11.3334 5.66732L9.00004 8.00065V6.33398H6.33337V5.00065H9.00004V3.33398ZM5.00004 10.6673L2.66671 8.33398L5.00004 6.00065V7.66732H7.66671V9.00065H5.00004V10.6673Z"
      fill="currentColor"
    />
  </Icon>
);

export const SplitArrow: IconProps = (props) => (
  <Icon viewBox="0 0 13.33 13.33" {...props}>
    <path
      d="M7.00004 0.333984C10.68 0.333984 13.6667 3.32065 13.6667 7.00065C13.6667 10.6807 10.68 13.6673 7.00004 13.6673C3.32004 13.6673 0.333374 10.6807 0.333374 7.00065C0.333374 3.32065 3.32004 0.333984 7.00004 0.333984ZM6.00004 3.66732H3.00004V6.66732L4.14504 5.52232L6.50004 7.87232V11.6673H7.50004V7.46232L4.85504 4.81232L6.00004 3.66732ZM11 3.66732H8.00004L9.14504 4.81232L7.70504 6.25232L8.41504 6.96232L9.85504 5.52232L11 6.66732V3.66732Z"
      fill="currentColor"
    />
  </Icon>
);

export const ReverseArrow: IconProps = (props) => (
  <Icon width="14" height="14" fill="none" viewBox="0 0 14 14" {...props}>
    <path
      d="M7.00004 0.333984C3.32004 0.333984 0.333374 3.32065 0.333374 7.00065C0.333374 10.6807 3.32004 13.6673 7.00004 13.6673C10.68 13.6673 13.6667 10.6807 13.6667 7.00065C13.6667 3.32065 10.68 0.333984 7.00004 0.333984ZM11 7.49398C10.92 9.55398 9.22004 11.254 7.16004 11.334C5.15337 11.414 3.45337 10.0073 3.08004 8.12065C3.02226 7.84954 2.99455 7.68565 2.99689 7.62898L4.33917 7.7054C4.34566 7.69488 4.3615 7.74885 4.38671 7.86732C4.66671 9.24732 6.01337 10.2473 7.53337 9.94732C8.57337 9.74732 9.41337 8.90732 9.61337 7.86732C9.94671 6.16065 8.64671 4.66732 7.00004 4.66732L6.99988 5.60478C6.99988 5.67626 6.99993 5.84005 7.00004 6.09614C6.55449 5.7844 6.32404 5.62061 6.30871 5.60478L4.56671 4.22024C4.50437 4.1579 4.34322 4.05416 4.33917 3.97474C4.33457 3.88431 4.49572 3.79733 4.56671 3.72634L6.53867 2.01846C6.60435 1.95483 6.75814 1.83469 7.00004 1.65805C7.00004 1.86347 7.00004 2.01999 7.00004 2.12763V3.33398C9.26004 3.33398 11.0867 5.21398 11 7.49398Z"
      fill="currentColor"
    />
  </Icon>
);
export const FillGrid: IconProps = (props) => (
  <Icon width="12" height="10" viewBox="0 0 12 10" fill="none" {...props}>
    <path
      d="M0.666667 6.33398H2C2.36667 6.33398 2.66667 6.03398 2.66667 5.66732V4.33398C2.66667 3.96732 2.36667 3.66732 2 3.66732H0.666667C0.3 3.66732 0 3.96732 0 4.33398V5.66732C0 6.03398 0.3 6.33398 0.666667 6.33398ZM0.666667 9.66732H2C2.36667 9.66732 2.66667 9.36732 2.66667 9.00065V7.66732C2.66667 7.30065 2.36667 7.00065 2 7.00065H0.666667C0.3 7.00065 0 7.30065 0 7.66732V9.00065C0 9.36732 0.3 9.66732 0.666667 9.66732ZM0.666667 3.00065H2C2.36667 3.00065 2.66667 2.70065 2.66667 2.33398V1.00065C2.66667 0.633984 2.36667 0.333984 2 0.333984H0.666667C0.3 0.333984 0 0.633984 0 1.00065V2.33398C0 2.70065 0.3 3.00065 0.666667 3.00065ZM4 6.33398H11.3333C11.7 6.33398 12 6.03398 12 5.66732V4.33398C12 3.96732 11.7 3.66732 11.3333 3.66732H4C3.63333 3.66732 3.33333 3.96732 3.33333 4.33398V5.66732C3.33333 6.03398 3.63333 6.33398 4 6.33398ZM4 9.66732H11.3333C11.7 9.66732 12 9.36732 12 9.00065V7.66732C12 7.30065 11.7 7.00065 11.3333 7.00065H4C3.63333 7.00065 3.33333 7.30065 3.33333 7.66732V9.00065C3.33333 9.36732 3.63333 9.66732 4 9.66732ZM3.33333 1.00065V2.33398C3.33333 2.70065 3.63333 3.00065 4 3.00065H11.3333C11.7 3.00065 12 2.70065 12 2.33398V1.00065C12 0.633984 11.7 0.333984 11.3333 0.333984H4C3.63333 0.333984 3.33333 0.633984 3.33333 1.00065Z"
      fill="currentColor"
    />
  </Icon>
);

export const ThList: IconProps = (props) => (
  <Icon width="12" height="10" viewBox="0 0 12 10" fill="none" {...props}>
    <path
      d="M0.666667 6.33398H2C2.36667 6.33398 2.66667 6.03398 2.66667 5.66732V4.33398C2.66667 3.96732 2.36667 3.66732 2 3.66732H0.666667C0.3 3.66732 0 3.96732 0 4.33398V5.66732C0 6.03398 0.3 6.33398 0.666667 6.33398ZM0.666667 9.66732H2C2.36667 9.66732 2.66667 9.36732 2.66667 9.00065V7.66732C2.66667 7.30065 2.36667 7.00065 2 7.00065H0.666667C0.3 7.00065 0 7.30065 0 7.66732V9.00065C0 9.36732 0.3 9.66732 0.666667 9.66732ZM0.666667 3.00065H2C2.36667 3.00065 2.66667 2.70065 2.66667 2.33398V1.00065C2.66667 0.633984 2.36667 0.333984 2 0.333984H0.666667C0.3 0.333984 0 0.633984 0 1.00065V2.33398C0 2.70065 0.3 3.00065 0.666667 3.00065ZM3.64103 6.33398H7.02564C7.19487 6.33398 7.33333 6.03398 7.33333 5.66732V4.33398C7.33333 3.96732 7.19487 3.66732 7.02564 3.66732H3.64103C3.47179 3.66732 3.33333 3.96732 3.33333 4.33398V5.66732C3.33333 6.03398 3.47179 6.33398 3.64103 6.33398ZM3.64103 9.66732H7.02564C7.19487 9.66732 7.33333 9.36732 7.33333 9.00065V7.66732C7.33333 7.30065 7.19487 7.00065 7.02564 7.00065H3.64103C3.47179 7.00065 3.33333 7.30065 3.33333 7.66732V9.00065C3.33333 9.36732 3.47179 9.66732 3.64103 9.66732ZM3.33333 1.00065V2.33398C3.33333 2.70065 3.47179 3.00065 3.64103 3.00065H7.02564C7.19487 3.00065 7.33333 2.70065 7.33333 2.33398V1.00065C7.33333 0.633984 7.19487 0.333984 7.02564 0.333984H3.64103C3.47179 0.333984 3.33333 0.633984 3.33333 1.00065ZM8.30769 6.33398H11.6923C11.8615 6.33398 12 6.03398 12 5.66732V4.33398C12 3.96732 11.8615 3.66732 11.6923 3.66732H8.30769C8.13846 3.66732 8 3.96732 8 4.33398V5.66732C8 6.03398 8.13846 6.33398 8.30769 6.33398ZM8.30769 9.66732H11.6923C11.8615 9.66732 12 9.36732 12 9.00065V7.66732C12 7.30065 11.8615 7.00065 11.6923 7.00065H8.30769C8.13846 7.00065 8 7.30065 8 7.66732V9.00065C8 9.36732 8.13846 9.66732 8.30769 9.66732ZM8 1.00065V2.33398C8 2.70065 8.13846 3.00065 8.30769 3.00065H11.6923C11.8615 3.00065 12 2.70065 12 2.33398V1.00065C12 0.633984 11.8615 0.333984 11.6923 0.333984H8.30769C8.13846 0.333984 8 0.633984 8 1.00065Z"
      fill="currentColor"
    />
  </Icon>
);

export const Settlements: IconProps = (props) => (
  <Icon
    width="21"
    height="18"
    viewBox="0 0 21 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6 18C10.7333 18 10.85 17.9833 10.95 17.95C11.05 17.9167 11.1667 17.8333 11.3 17.7L19.625 9.35C19.9083 9.06667 20.125 8.754 20.275 8.412C20.425 8.07067 20.5 7.73333 20.5 7.4C20.5 6.91667 20.4293 6.49167 20.288 6.125C20.146 5.75833 19.925 5.425 19.625 5.125L15.4 0.875C15.1 0.575 14.7667 0.354 14.4 0.212C14.0333 0.0706666 13.6333 0 13.2 0C12.85 0 12.5 0.0706666 12.15 0.212C11.8 0.354 11.4833 0.558333 11.2 0.825L15.675 5.3C15.8917 5.51667 16.0417 5.75 16.125 6C16.2083 6.25 16.25 6.49167 16.25 6.725C16.25 7.30833 16.05 7.78733 15.65 8.162C15.25 8.53733 14.7833 8.725 14.25 8.725C14 8.725 13.75 8.67067 13.5 8.562C13.25 8.454 13.0333 8.30833 12.85 8.125L9.1 4.35L3.525 9.925C3.425 10.025 3.35 10.1333 3.3 10.25C3.25 10.3667 3.225 10.4917 3.225 10.625C3.225 10.9083 3.321 11.1457 3.513 11.337C3.70433 11.529 3.94167 11.625 4.225 11.625C4.39167 11.625 4.53333 11.6 4.65 11.55C4.76667 11.5 4.86667 11.4333 4.95 11.35L9.55 6.725L10.275 7.425L5.65 12.05C5.55 12.15 5.475 12.2583 5.425 12.375C5.375 12.4917 5.35 12.6167 5.35 12.75C5.35 13.0167 5.45 13.25 5.65 13.45C5.85 13.65 6.08333 13.75 6.35 13.75C6.5 13.75 6.63333 13.725 6.75 13.675C6.86667 13.625 6.975 13.55 7.075 13.45L11.7 8.85L12.4 9.55L7.775 14.175C7.69167 14.2583 7.625 14.354 7.575 14.462C7.525 14.5707 7.5 14.7083 7.5 14.875C7.5 15.1583 7.596 15.3957 7.788 15.587C7.97933 15.779 8.21667 15.875 8.5 15.875C8.63333 15.875 8.75833 15.85 8.875 15.8C8.99167 15.75 9.1 15.675 9.2 15.575L13.8 10.95L14.525 11.675L9.9 16.3C9.8 16.4 9.725 16.5123 9.675 16.637C9.625 16.7623 9.6 16.8833 9.6 17C9.6 17.2833 9.696 17.5207 9.888 17.712C10.0793 17.904 10.3167 18 10.6 18ZM2.025 10L9.075 2.95L13.575 7.4C13.6917 7.51667 13.8 7.59567 13.9 7.637C14 7.679 14.125 7.7 14.275 7.7C14.5417 7.7 14.775 7.6 14.975 7.4C15.175 7.2 15.275 6.96667 15.275 6.7C15.275 6.56667 15.25 6.44167 15.2 6.325C15.15 6.20833 15.075 6.1 14.975 6L9.85 0.875C9.51667 0.541667 9.175 0.312667 8.825 0.188C8.475 0.0626666 8.075 0 7.625 0C7.275 0 6.91667 0.079 6.55 0.237C6.18333 0.395667 5.86667 0.608333 5.6 0.875L1.375 5.125C1.125 5.375 0.916667 5.68333 0.75 6.05C0.583333 6.41667 0.5 6.81667 0.5 7.25C0.5 7.65 0.575 8.03333 0.725 8.4C0.875 8.76667 1.09167 9.08333 1.375 9.35L2.025 10Z"
      fill="currentColor"
    />
  </Icon>
);

export const Transactions: IconProps = (props) => (
  <Icon
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 20C2.66667 20 1.95833 19.7083 1.375 19.125C0.791667 18.5417 0.5 17.8333 0.5 17V14H3.5V0L5 1.5L6.5 0L8 1.5L9.5 0L11 1.5L12.5 0L14 1.5L15.5 0L17 1.5L18.5 0V17C18.5 17.8333 18.2083 18.5417 17.625 19.125C17.0417 19.7083 16.3333 20 15.5 20H3.5ZM15.5 18C15.7833 18 16.0207 17.904 16.212 17.712C16.404 17.5207 16.5 17.2833 16.5 17V3H5.5V14H14.5V17C14.5 17.2833 14.596 17.5207 14.788 17.712C14.9793 17.904 15.2167 18 15.5 18ZM6.5 7V5H12.5V7H6.5ZM6.5 10V8H12.5V10H6.5ZM14.5 7C14.2167 7 13.9793 6.904 13.788 6.712C13.596 6.52067 13.5 6.28333 13.5 6C13.5 5.71667 13.596 5.479 13.788 5.287C13.9793 5.09567 14.2167 5 14.5 5C14.7833 5 15.0207 5.09567 15.212 5.287C15.404 5.479 15.5 5.71667 15.5 6C15.5 6.28333 15.404 6.52067 15.212 6.712C15.0207 6.904 14.7833 7 14.5 7ZM14.5 10C14.2167 10 13.9793 9.904 13.788 9.712C13.596 9.52067 13.5 9.28333 13.5 9C13.5 8.71667 13.596 8.479 13.788 8.287C13.9793 8.09567 14.2167 8 14.5 8C14.7833 8 15.0207 8.09567 15.212 8.287C15.404 8.479 15.5 8.71667 15.5 9C15.5 9.28333 15.404 9.52067 15.212 9.712C15.0207 9.904 14.7833 10 14.5 10Z"
      fill="currentColor"
    />
  </Icon>
);

export const Paid: IconProps = (props) => (
  <Icon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_16_4157"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16_4157)">
      <path
        d="M11.1 19H12.85V17.75C13.6833 17.6 14.4 17.275 15 16.775C15.6 16.275 15.9 15.5333 15.9 14.55C15.9 13.85 15.7 13.2083 15.3 12.625C14.9 12.0417 14.1 11.5333 12.9 11.1C11.9 10.7667 11.2083 10.475 10.825 10.225C10.4417 9.975 10.25 9.63333 10.25 9.2C10.25 8.76667 10.4043 8.425 10.713 8.175C11.021 7.925 11.4667 7.8 12.05 7.8C12.5833 7.8 13 7.92933 13.3 8.188C13.6 8.446 13.8167 8.76667 13.95 9.15L15.55 8.5C15.3667 7.91667 15.0293 7.40833 14.538 6.975C14.046 6.54167 13.5 6.3 12.9 6.25V5H11.15V6.25C10.3167 6.43333 9.66667 6.8 9.2 7.35C8.73333 7.9 8.5 8.51667 8.5 9.2C8.5 9.98333 8.72933 10.6167 9.188 11.1C9.646 11.5833 10.3667 12 11.35 12.35C12.4 12.7333 13.1293 13.075 13.538 13.375C13.946 13.675 14.15 14.0667 14.15 14.55C14.15 15.1 13.954 15.504 13.562 15.762C13.1707 16.0207 12.7 16.15 12.15 16.15C11.6 16.15 11.1127 15.979 10.688 15.637C10.2627 15.2957 9.95 14.7833 9.75 14.1L8.1 14.75C8.33333 15.55 8.696 16.196 9.188 16.688C9.67933 17.1793 10.3167 17.5167 11.1 17.7V19ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22Z"
        fill="#118061"
      />
    </g>
  </Icon>
);

export const Refund: IconProps = (props) => (
  <Icon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_16_4176"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16_4176)">
      <path
        d="M11.19 18.3H12.765V17.175C13.515 17.04 14.16 16.7475 14.7 16.2975C15.24 15.8475 15.51 15.18 15.51 14.295C15.51 13.665 15.33 13.0875 14.97 12.5625C14.61 12.0375 13.89 11.58 12.81 11.19C11.91 10.89 11.2875 10.6275 10.9425 10.4025C10.5975 10.1775 10.425 9.87001 10.425 9.48001C10.425 9.09001 10.5639 8.78251 10.8417 8.55751C11.1189 8.33251 11.52 8.22001 12.045 8.22001C12.525 8.22001 12.9 8.33641 13.17 8.56921C13.44 8.80141 13.635 9.09001 13.755 9.43501L15.195 8.85001C15.03 8.32501 14.7264 7.86751 14.2842 7.47751C13.8414 7.08751 13.35 6.87001 12.81 6.82501V5.70001H11.235V6.82501C10.485 6.99001 9.89999 7.32001 9.47999 7.81501C9.05999 8.31001 8.84999 8.86501 8.84999 9.48001C8.84999 10.185 9.05639 10.755 9.46919 11.19C9.88139 11.625 10.53 12 11.415 12.315C12.36 12.66 13.0164 12.9675 13.3842 13.2375C13.7514 13.5075 13.935 13.86 13.935 14.295C13.935 14.79 13.7586 15.1536 13.4058 15.3858C13.0536 15.6186 12.63 15.735 12.135 15.735C11.64 15.735 11.2014 15.5811 10.8192 15.2733C10.4364 14.9661 10.155 14.505 9.97499 13.89L8.48999 14.475C8.69999 15.195 9.02639 15.7764 9.46919 16.2192C9.91139 16.6614 10.485 16.965 11.19 17.13V18.3Z"
        fill="#FEC35D"
      />
      <path
        d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C9.66849 22.0034 7.40966 21.1888 5.61701 19.698L5.37301 19.489L6.27501 17.587C7.56299 18.9071 9.26753 19.7416 11.1001 19.9493C12.9327 20.157 14.7808 19.7252 16.3316 18.7268C17.8823 17.7285 19.0405 16.225 19.6101 14.4708C20.1796 12.7166 20.1256 10.8195 19.4571 9.1006C18.7886 7.38169 17.5468 5.94654 15.9417 5.03807C14.3366 4.1296 12.467 3.80362 10.6492 4.1153C8.83135 4.42697 7.17707 5.35717 5.96632 6.74843C4.75556 8.1397 4.0627 9.90657 4.00501 11.75L4.00001 12H6.50001L3.79401 17.716C2.62322 16.0401 1.99685 14.0444 2.00001 12C2.00001 6.477 6.47701 2 12 2Z"
        fill="#FEC35D"
      />
    </g>
  </Icon>
);

export const Pending: IconProps = (props) => (
  <Icon
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_16_4234"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="25"
      height="24"
    >
      <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16_4234)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.93802 20.887C9.02936 21.4623 10.2084 21.8167 11.475 21.95V19.95C9.47503 19.6667 7.81669 18.7707 6.50002 17.262C5.18336 15.754 4.52502 13.9917 4.52502 11.975C4.52502 9.95833 5.18336 8.19567 6.50002 6.687C7.81669 5.179 9.48336 4.28333 11.5 4V2C8.93336 2.28333 6.79602 3.37067 5.08802 5.262C3.37936 7.154 2.52502 9.39167 2.52502 11.975C2.52502 13.2583 2.75436 14.475 3.21302 15.625C3.67102 16.775 4.30002 17.796 5.10002 18.688C5.90002 19.5793 6.84602 20.3123 7.93802 20.887ZM13.475 19.95V21.95C14.4584 21.85 15.4 21.6127 16.3 21.238C17.2 20.8627 18.0417 20.3667 18.825 19.75L17.375 18.3C16.8084 18.7333 16.196 19.0917 15.538 19.375C14.8794 19.6583 14.1917 19.85 13.475 19.95ZM15.562 4.575C16.2207 4.85833 16.8417 5.21667 17.425 5.65L18.825 4.2C18.0584 3.58333 17.225 3.08733 16.325 2.712C15.425 2.33733 14.4834 2.1 13.5 2V4C14.2167 4.1 14.904 4.29167 15.562 4.575ZM18.825 16.875L20.225 18.3C20.8584 17.55 21.3584 16.7207 21.725 15.812C22.0917 14.904 22.3417 13.9583 22.475 12.975H20.425C20.325 13.6917 20.1417 14.379 19.875 15.037C19.6084 15.6957 19.2584 16.3083 18.825 16.875ZM19.875 8.912C20.1417 9.57067 20.325 10.2583 20.425 10.975H22.475C22.375 9.99167 22.1334 9.04567 21.75 8.137C21.3667 7.229 20.8584 6.4 20.225 5.65L18.825 7.075C19.2584 7.64167 19.6084 8.254 19.875 8.912ZM11.5 12.4L15.8 16.7L17.2 15.3L13.5 11.6V7H11.5V12.4Z"
        fill="#FEC35D"
      />
    </g>
  </Icon>
);

export const Completed: IconProps = (props) => (
  <Icon
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_16_4231"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="25"
      height="24"
    >
      <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16_4231)">
      <path
        d="M11.1 16.6L18.15 9.55L16.75 8.15L11.1 13.8L8.25 10.95L6.85 12.35L11.1 16.6ZM12.5 22C11.1167 22 9.81667 21.7373 8.6 21.212C7.38333 20.6873 6.325 19.975 5.425 19.075C4.525 18.175 3.81267 17.1167 3.288 15.9C2.76267 14.6833 2.5 13.3833 2.5 12C2.5 10.6167 2.76267 9.31667 3.288 8.1C3.81267 6.88333 4.525 5.825 5.425 4.925C6.325 4.025 7.38333 3.31233 8.6 2.787C9.81667 2.26233 11.1167 2 12.5 2C13.8833 2 15.1833 2.26233 16.4 2.787C17.6167 3.31233 18.675 4.025 19.575 4.925C20.475 5.825 21.1873 6.88333 21.712 8.1C22.2373 9.31667 22.5 10.6167 22.5 12C22.5 13.3833 22.2373 14.6833 21.712 15.9C21.1873 17.1167 20.475 18.175 19.575 19.075C18.675 19.975 17.6167 20.6873 16.4 21.212C15.1833 21.7373 13.8833 22 12.5 22Z"
        fill="#118061"
      />
    </g>
  </Icon>
);

export const Failed: IconProps = (props) => (
  <Icon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_16_4223"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16_4223)">
      <path
        d="M8.4 17L12 13.4L15.6 17L17 15.6L13.4 12L17 8.4L15.6 7L12 10.6L8.4 7L7 8.4L10.6 12L7 15.6L8.4 17ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22Z"
        fill="#D62F1D"
      />
    </g>
  </Icon>
);

export const InProgress: IconProps = (props) => (
  <Icon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_16_4291"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="25"
      height="24"
    >
      <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16_4291)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.6 21.212C9.81667 21.7373 11.1167 22 12.5 22C13.8833 22 15.1833 21.7373 16.4 21.212C17.6167 20.6873 18.675 19.975 19.575 19.075C20.475 18.175 21.1873 17.1167 21.712 15.9C22.2373 14.6833 22.5 13.3833 22.5 12C22.5 10.6167 22.2373 9.31667 21.712 8.1C21.1873 6.88333 20.475 5.825 19.575 4.925C18.675 4.025 17.6167 3.31233 16.4 2.787C15.1833 2.26233 13.8833 2 12.5 2C11.1167 2 9.81667 2.26233 8.6 2.787C7.38333 3.31233 6.325 4.025 5.425 4.925C4.525 5.825 3.81267 6.88333 3.288 8.1C2.76267 9.31667 2.5 10.6167 2.5 12C2.5 13.3833 2.76267 14.6833 3.288 15.9C3.81267 17.1167 4.525 18.175 5.425 19.075C6.325 19.975 7.38333 20.6873 8.6 21.212ZM18.175 17.675C16.625 19.225 14.7333 20 12.5 20C10.2667 20 8.375 19.225 6.825 17.675C5.275 16.125 4.5 14.2333 4.5 12C4.5 9.76667 5.275 7.875 6.825 6.325C8.375 4.775 10.2667 4 12.5 4C14.7333 4 16.625 4.775 18.175 6.325C19.725 7.875 20.5 9.76667 20.5 12C20.5 14.2333 19.725 16.125 18.175 17.675ZM15.7998 5.82655C14.7845 5.2839 13.6512 5 12.5 5V12L7.55025 16.9497C8.36424 17.7637 9.36642 18.3644 10.468 18.6986C11.5696 19.0327 12.7366 19.0901 13.8656 18.8655C14.9947 18.6409 16.0509 18.1414 16.9408 17.4111C17.8306 16.6808 18.5266 15.7423 18.9672 14.6788C19.4077 13.6153 19.5791 12.4595 19.4663 11.3139C19.3535 10.1683 18.9598 9.06816 18.3203 8.11101C17.6807 7.15386 16.815 6.3692 15.7998 5.82655Z"
        fill="#0080C2"
      />
    </g>
  </Icon>
);

export const Notifications: IconProps = (props) => (
  <Icon
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="60" height="60" rx="2" fill="#FBE8E6" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.9995 14C21.1633 14 14 21.1638 14 29.9997C14 38.8355 21.1633 46 29.9995 46C38.8356 46 45.9998 38.8359 45.9998 29.9997C45.9998 21.1634 38.8356 14 29.9995 14ZM29.9998 38.8481C28.8514 38.8481 27.9199 37.9174 27.9199 36.7682H32.0794C32.0796 37.9174 31.1482 38.8481 29.9998 38.8481ZM37.0281 34.6827H37.0275V34.6826C37.0275 35.4516 36.4043 35.5023 35.6357 35.5023H24.3636C23.5948 35.5023 22.9721 35.4516 22.9721 34.6826V34.5501C22.9721 33.997 23.2969 33.5234 23.7635 33.2988L24.2053 29.4851C24.2053 26.6932 26.1797 24.363 28.8082 23.8132V22.3327C28.8082 21.6746 29.3419 21.1409 30.0003 21.1409C30.6585 21.1409 31.1921 21.6746 31.1921 22.3327V23.8133C33.8206 24.363 35.795 26.693 35.795 29.4852L36.2368 33.2994C36.7035 33.5244 37.0281 33.9971 37.0281 34.5502V34.6827Z"
      fill="#D62F1D"
    />
  </Icon>
);

export const RevenueChart: IconProps = (props) => (
  <Icon
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="60" height="60" rx="2" fill="#E3F1F8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30 46C27.3333 46 24.8864 45.4133 22.6592 44.24C20.4331 43.0667 18.5867 41.4933 17.12 39.52L23.68 32.96L28.48 36.96L36.4 29.04V33.2H39.6V23.6H30V26.8H34.16L28.32 32.64L23.52 28.64L15.44 36.72C14.9867 35.7067 14.6331 34.6336 14.3792 33.5008C14.1264 32.3669 14 31.2 14 30C14 27.7867 14.4203 25.7067 15.2608 23.76C16.1003 21.8133 17.24 20.12 18.68 18.68C20.12 17.24 21.8133 16.0997 23.76 15.2592C25.7067 14.4197 27.7867 14 30 14C32.2133 14 34.2933 14.4197 36.24 15.2592C38.1867 16.0997 39.88 17.24 41.32 18.68C42.76 20.12 43.8997 21.8133 44.7392 23.76C45.5797 25.7067 46 27.7867 46 30C46 32.2133 45.5797 34.2933 44.7392 36.24C43.8997 38.1867 42.76 39.88 41.32 41.32C39.88 42.76 38.1867 43.8997 36.24 44.7392C34.2933 45.5797 32.2133 46 30 46Z"
      fill="#0080C2"
    />
  </Icon>
);

export const PendingSettlement: IconProps = (props) => (
  <Icon
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="60" height="60" rx="2" fill="#FFF8ED" />
    <mask
      id="mask0_16_4640"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="14"
      y="14"
      width="32"
      height="32"
    >
      <rect x="14" y="14" width="32" height="32" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16_4640)">
      <path
        d="M28.3559 46C26.3241 45.7861 24.433 45.2178 22.6825 44.2949C20.9309 43.3732 19.4135 42.1974 18.1303 40.7677C16.8471 39.3369 15.8382 37.6992 15.1036 35.8546C14.3679 34.01 14 32.0585 14 30C14 25.8563 15.3704 22.2671 18.1111 19.2323C20.8507 16.1986 24.279 14.4545 28.396 14V17.208C25.1612 17.6625 22.4879 19.0991 20.3759 21.518C18.264 23.9379 17.208 26.7652 17.208 30C17.208 33.2348 18.264 36.0616 20.3759 38.4804C22.4879 40.9003 25.1479 42.3375 28.3559 42.792V46ZM31.5639 46V42.792C32.7135 42.6316 33.8165 42.3241 34.873 41.8697C35.9284 41.4152 36.9106 40.8404 37.8195 40.1454L40.1454 42.4712C38.8889 43.4603 37.5388 44.2559 36.0952 44.8579C34.6516 45.4589 33.1412 45.8396 31.5639 46ZM37.8997 19.8546C36.9641 19.1596 35.968 18.5848 34.9115 18.1303C33.856 17.6759 32.7536 17.3684 31.604 17.208V14C33.1813 14.1604 34.6917 14.5411 36.1353 15.1421C37.5789 15.7441 38.9156 16.5397 40.1454 17.5288L37.8997 19.8546ZM42.391 40.1454L40.1454 37.8596C40.8404 36.9507 41.4018 35.968 41.8296 34.9115C42.2573 33.856 42.5514 32.7536 42.7118 31.604H46C45.7861 33.1813 45.3851 34.6981 44.797 36.1546C44.2089 37.6121 43.4069 38.9424 42.391 40.1454ZM42.7118 28.396C42.5514 27.2464 42.2573 26.1434 41.8296 25.0869C41.4018 24.0315 40.8404 23.0493 40.1454 22.1404L42.391 19.8546C43.4069 21.0576 44.2222 22.3874 44.8371 23.8438C45.452 25.3013 45.8396 26.8187 46 28.396H42.7118Z"
        fill="#D5A44E"
      />
      <path
        d="M29.8556 37C29.9593 37 30.05 36.987 30.1278 36.9611C30.2056 36.9352 30.2963 36.8704 30.4 36.7667L36.875 30.2722C37.0954 30.0519 37.2639 29.8087 37.3806 29.5427C37.4972 29.2772 37.5556 29.0148 37.5556 28.7556C37.5556 28.3796 37.5006 28.0491 37.3907 27.7639C37.2802 27.4787 37.1083 27.2194 36.875 26.9861L33.5889 23.6806C33.3556 23.4472 33.0963 23.2753 32.8111 23.1649C32.5259 23.055 32.2148 23 31.8778 23C31.6056 23 31.3333 23.055 31.0611 23.1649C30.7889 23.2753 30.5426 23.4343 30.3222 23.6417L33.8028 27.1222C33.9713 27.2907 34.088 27.4722 34.1528 27.6667C34.2176 27.8611 34.25 28.0491 34.25 28.2306C34.25 28.6843 34.0944 29.0568 33.7833 29.3482C33.4722 29.6401 33.1093 29.7861 32.6944 29.7861C32.5 29.7861 32.3056 29.7439 32.1111 29.6593C31.9167 29.5753 31.7481 29.462 31.6056 29.3194L28.6889 26.3833L24.3528 30.7194C24.275 30.7972 24.2167 30.8815 24.1778 30.9722C24.1389 31.063 24.1194 31.1602 24.1194 31.2639C24.1194 31.4843 24.1941 31.6689 24.3434 31.8177C24.4923 31.967 24.6769 32.0417 24.8972 32.0417C25.0269 32.0417 25.137 32.0222 25.2278 31.9833C25.3185 31.9444 25.3963 31.8926 25.4611 31.8278L29.0389 28.2306L29.6028 28.775L26.0056 32.3722C25.9278 32.45 25.8694 32.5343 25.8306 32.625C25.7917 32.7157 25.7722 32.813 25.7722 32.9167C25.7722 33.1241 25.85 33.3056 26.0056 33.4611C26.1611 33.6167 26.3426 33.6944 26.55 33.6944C26.6667 33.6944 26.7704 33.675 26.8611 33.6361C26.9519 33.5972 27.0361 33.5389 27.1139 33.4611L30.7111 29.8833L31.2556 30.4278L27.6583 34.025C27.5935 34.0898 27.5417 34.1642 27.5028 34.2482C27.4639 34.3327 27.4444 34.4398 27.4444 34.5694C27.4444 34.7898 27.5191 34.9744 27.6684 35.1232C27.8173 35.2726 28.0019 35.3472 28.2222 35.3472C28.3259 35.3472 28.4231 35.3278 28.5139 35.2889C28.6046 35.25 28.6889 35.1917 28.7667 35.1139L32.3444 31.5167L32.9083 32.0806L29.3111 35.6778C29.2333 35.7556 29.175 35.8429 29.1361 35.9399C29.0972 36.0374 29.0778 36.1315 29.0778 36.2222C29.0778 36.4426 29.1524 36.6272 29.3018 36.776C29.4506 36.9253 29.6352 37 29.8556 37ZM23.1861 30.7778L28.6694 25.2944L32.1694 28.7556C32.2602 28.8463 32.3444 28.9077 32.4222 28.9399C32.5 28.9726 32.5972 28.9889 32.7139 28.9889C32.9213 28.9889 33.1028 28.9111 33.2583 28.7556C33.4139 28.6 33.4917 28.4185 33.4917 28.2111C33.4917 28.1074 33.4722 28.0102 33.4333 27.9194C33.3944 27.8287 33.3361 27.7444 33.2583 27.6667L29.2722 23.6806C29.013 23.4213 28.7472 23.2432 28.475 23.1462C28.2028 23.0487 27.8917 23 27.5417 23C27.2694 23 26.9907 23.0614 26.7056 23.1843C26.4204 23.3077 26.1741 23.4731 25.9667 23.6806L22.6806 26.9861C22.4861 27.1806 22.3241 27.4204 22.1944 27.7056C22.0648 27.9907 22 28.3019 22 28.6389C22 28.95 22.0583 29.2481 22.175 29.5333C22.2917 29.8185 22.4602 30.0648 22.6806 30.2722L23.1861 30.7778Z"
        fill="#D5A44E"
      />
    </g>
  </Icon>
);

const Icons: Record<string, React.FC<IconProps>> = {
  AccountsManagement,
  Accounts,
  Add,
  ArrowDownward,
  ArrowUpward,
  Backspace,
  BlackListed,
  Broom,
  BookingSourceView,
  CalendarAdd,
  CalendarEvent,
  CalendarMain,
  CalendarOutline,
  CaretCheck,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  CheckCircle,
  Clock,
  Clog,
  Close,
  CloseAccount,
  Collapse,
  CreditCard,
  Customer,
  Dashboard,
  DetailView,
  Dollar,
  Download,
  Duplicate,
  Email,
  EmailLog,
  EmailServices,
  Emoji,
  Empty,
  ExternalLink,
  File,
  Filter,
  Fire,
  FormatAlignCenter,
  FormatAlignJustify,
  FormatAlignLeft,
  FormatAlignRight,
  FormatBold,
  FormatItalic,
  FormatListBullet,
  FormatListNumber,
  FormatTextColor,
  FormatUnderline,
  GroupView,
  Help,
  Image,
  InfoCircle,
  Inventory,
  Links,
  Lock,
  Logout,
  Loyalty,
  Minus,
  MonthView,
  MoreHorizontal,
  NightlyRatesView,
  NormalView,
  Palette,
  Password,
  Pin,
  Print,
  Progress,
  QuarterView,
  Reverse,
  RoomAvailabilities,
  RowCondense,
  ScrollDown,
  ScrollUp,
  Search,
  SendFeedback,
  Sort,
  SortDown,
  SortUp,
  Split,
  Star,
  SetOfStars,
  Stop,
  Switch,
  Template,
  ToggleOff,
  ToggleOn,
  Trash,
  Undo,
  Unlink,
  Upload,
  View,
  Warning,
  ViewInput,
  Preview,
  Refresh,
  SendText,
  NoShow,
  Group,
  Company,
  Profile,
  ArrowLeftRight,
  SplitArrow,
  ReverseArrow,
  FillGrid,
  ThList,
  Settlements,
  Transactions,
  Paid,
  Refund,
  Pending,
  Completed,
  Failed,
  InProgress,
  Notifications,
  RevenueChart,
  PendingSettlement,
};
export default Icons;
